(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glowpups-bandana-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bandana-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bandana-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var slideIndex = 0;
  var stage = section.querySelector('.gp-hero__stage');
  var priceEl = section.querySelector('[data-hero-price]');
  var variantInput = section.querySelector('[data-hero-variant-input]');
  var ctaBtn = section.querySelector('[data-hero-cta]');
  var sizeSelected = section.querySelector('[data-size-selected]');

  function formatMoney(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function render() {
      slides.forEach(function (el, i) { el.classList.toggle('gp-hero__slide--active', i === slideIndex); });
      thumbs.forEach(function (el, i) { el.classList.toggle('gp-hero__thumb--active', i === slideIndex); });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex - 1 + slides.length) % slides.length; render(); } };
    if (nextBtn) nextBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex + 1) % slides.length; render(); } };
    thumbs.forEach(function (el, i) { el.onclick = function () { slideIndex = i; render(); }; });
    render();
  }
  bindGallery();

  // ---------- Variant selector ----------
  var defaultCtaLabel = ctaBtn ? ctaBtn.textContent.trim() : 'Add to Cart';
  function selectSize(btn) {
    if (btn.getAttribute('data-variant-available') !== 'true') return;
    section.querySelectorAll('.gp-hero__size-btn').forEach(function (el) {
      var on = el === btn;
      el.classList.toggle('gp-hero__size-btn--active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-variant-title');
    var price = parseInt(btn.getAttribute('data-variant-price'), 10);
    if (variantInput) variantInput.value = id;
    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    if (sizeSelected) sizeSelected.textContent = ' · ' + title;
    if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.textContent = defaultCtaLabel; }
    // Swap the gallery to this variant's photo via the existing position-indexed slides.
    var slideTarget = btn.getAttribute('data-variant-slide');
    if (slideTarget !== null && slideTarget !== '') {
      var sIdx = parseInt(slideTarget, 10);
      var vSlides = section.querySelectorAll('.gp-hero__slide');
      var vThumbs = section.querySelectorAll('.gp-hero__thumb');
      if (!isNaN(sIdx) && sIdx >= 0 && sIdx < vSlides.length) {
        vSlides.forEach(function (el, i) { el.classList.toggle('gp-hero__slide--active', i === sIdx); });
        vThumbs.forEach(function (el, i) { el.classList.toggle('gp-hero__thumb--active', i === sIdx); });
        slideIndex = sIdx;
      }
    }
    // Deep-link: reflect the chosen variant in the URL so the photo/price is shareable.
    try {
      var vUrl = new URL(window.location.href);
      vUrl.searchParams.set('variant', id);
      window.history.replaceState({}, '', vUrl);
    } catch (e) { /* noop */ }
    document.dispatchEvent(new CustomEvent('gp:variantChanged', {
      detail: { variantId: id, title: title, priceCents: isNaN(price) ? null : price, available: true }
    }));
  }
  section.querySelectorAll('.gp-hero__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { selectSize(btn); });
  });
  // Deep-link: pre-select the variant from ?variant= on load (sets photo + price + active state).
  try {
    var qsVariant = new URL(window.location.href).searchParams.get('variant');
    if (qsVariant) {
      var preBtn = section.querySelector('.gp-hero__size-btn[data-variant-id="' + qsVariant + '"]');
      if (preBtn && preBtn.getAttribute('data-variant-available') === 'true') selectSize(preBtn);
    }
  } catch (e) { /* noop */ }

  // ---------- Quantity ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');
  function setQty(n) { var v = parseInt(n, 10); if (isNaN(v) || v < 1) v = 1; if (qtyInput) qtyInput.value = v; }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) { qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); }); }

  // ---------- Cross-promo add to cart ----------
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
  };
  function transientAdded(btn) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added';
    btn.dataset.added = '1';
  }
  section.querySelectorAll('[data-xsell-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.added === '1') return;
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      window.GP_ADD_TO_CART([{ id: id, quantity: 1 }])
        .then(function () { transientAdded(btn); })
        .catch(function () { transientAdded(btn); });
    });
  });

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '').replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi; lightboxImg.alt = alt || '';
    lightbox.hidden = false; lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open'); lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) stage.addEventListener('click', function (e) {
    var img = e.target.closest('.gp-hero__photo');
    if (img) { e.preventDefault(); openLightbox(img.src, img.alt); }
  });
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target === lightboxImg) closeLightbox(); });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  // ---------- Size-guide modal ----------
  var sg = section.querySelector('[data-sizeguide]');
  function openSizeGuide() { if (!sg) return; sg.hidden = false; sg.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeSizeGuide() { if (!sg) return; sg.classList.remove('is-open'); sg.hidden = true; document.documentElement.style.overflow = ''; }
  section.querySelectorAll('[data-open-sizeguide]').forEach(function (b) { b.addEventListener('click', openSizeGuide); });
  if (sg) {
    sg.addEventListener('click', function (e) { if (e.target === sg) closeSizeGuide(); });
    var sgClose = sg.querySelector('[data-close-sizeguide]');
    if (sgClose) sgClose.addEventListener('click', closeSizeGuide);
  }
  if (sg && window.location.hash === '#size-guide') openSizeGuide();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#size-guide"]');
    if (a && sg) { e.preventDefault(); openSizeGuide(); }
  });

  // ---------- Escape ----------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && !lightbox.hidden) closeLightbox();
    if (sg && !sg.hidden) closeSizeGuide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bandana-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Variant (Style) changes from the hero update the sticky bar's label + price.
  document.addEventListener('gp:variantChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.title) {
      colorLabel.textContent = detail.title;
    }
    if (priceEl && typeof detail.priceCents === 'number') {
      priceEl.textContent = formatMoney(detail.priceCents);
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bandana-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bed-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bed-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bed-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var slideIndex = 0;
  var stage = section.querySelector('.gp-hero__stage');
  var priceEl = section.querySelector('[data-hero-price]');
  var variantInput = section.querySelector('[data-hero-variant-input]');
  var ctaBtn = section.querySelector('[data-hero-cta]');
  var sizeSelected = section.querySelector('[data-size-selected]');

  function formatMoney(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function render() {
      slides.forEach(function (el, i) { el.classList.toggle('gp-hero__slide--active', i === slideIndex); });
      thumbs.forEach(function (el, i) { el.classList.toggle('gp-hero__thumb--active', i === slideIndex); });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex - 1 + slides.length) % slides.length; render(); } };
    if (nextBtn) nextBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex + 1) % slides.length; render(); } };
    thumbs.forEach(function (el, i) { el.onclick = function () { slideIndex = i; render(); }; });
    render();
  }
  bindGallery();

  // ---------- Variant selector ----------
  var defaultCtaLabel = ctaBtn ? ctaBtn.textContent.trim() : 'Add to Cart';
  function selectSize(btn) {
    if (btn.getAttribute('data-variant-available') !== 'true') return;
    section.querySelectorAll('.gp-hero__size-btn').forEach(function (el) {
      var on = el === btn;
      el.classList.toggle('gp-hero__size-btn--active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-variant-title');
    var price = parseInt(btn.getAttribute('data-variant-price'), 10);
    if (variantInput) variantInput.value = id;
    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    if (sizeSelected) sizeSelected.textContent = ' · ' + title;
    if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.textContent = defaultCtaLabel; }
    document.dispatchEvent(new CustomEvent('gp:variantChanged', {
      detail: { variantId: id, title: title, priceCents: isNaN(price) ? null : price, available: true }
    }));
  }
  section.querySelectorAll('.gp-hero__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { selectSize(btn); });
  });

  // ---------- Quantity ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');
  function setQty(n) { var v = parseInt(n, 10); if (isNaN(v) || v < 1) v = 1; if (qtyInput) qtyInput.value = v; }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) { qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); }); }

  // ---------- Cross-promo add to cart ----------
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
  };
  function transientAdded(btn) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added';
    btn.dataset.added = '1';
  }
  section.querySelectorAll('[data-xsell-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.added === '1') return;
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      window.GP_ADD_TO_CART([{ id: id, quantity: 1 }])
        .then(function () { transientAdded(btn); })
        .catch(function () { transientAdded(btn); });
    });
  });

  // ---------- Cross-sell color-swatch group (pick a color, Add adds that product) ----------
  section.querySelectorAll('[data-xsg]').forEach(function (group) {
    var thumb = group.querySelector('[data-xsg-thumb]');
    var thumbLink = group.querySelector('[data-xsg-thumblink]');
    var nameEl = group.querySelector('[data-xsg-name]');
    var priceEl = group.querySelector('[data-xsg-price]');
    var addBtn = group.querySelector('[data-xsell-add]');
    group.querySelectorAll('[data-xsg-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('[data-xsg-swatch]').forEach(function (s) {
          var on = s === sw;
          s.classList.toggle('gp-hero__xsg-swatch--active', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (thumb) { thumb.src = sw.dataset.thumb; thumb.alt = sw.dataset.title; }
        if (thumbLink) thumbLink.href = sw.dataset.url;
        if (nameEl) { nameEl.textContent = sw.dataset.title; nameEl.href = sw.dataset.url; }
        if (priceEl) priceEl.textContent = sw.dataset.price;
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', sw.dataset.variantId);
          addBtn.disabled = sw.dataset.available !== 'true';
        }
      });
    });
  });

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '').replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi; lightboxImg.alt = alt || '';
    lightbox.hidden = false; lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open'); lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) stage.addEventListener('click', function (e) {
    var img = e.target.closest('.gp-hero__photo');
    if (img) { e.preventDefault(); openLightbox(img.src, img.alt); }
  });
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target === lightboxImg) closeLightbox(); });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  // ---------- Size-guide modal ----------
  var sg = section.querySelector('[data-sizeguide]');
  function openSizeGuide() { if (!sg) return; sg.hidden = false; sg.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeSizeGuide() { if (!sg) return; sg.classList.remove('is-open'); sg.hidden = true; document.documentElement.style.overflow = ''; }
  section.querySelectorAll('[data-open-sizeguide]').forEach(function (b) { b.addEventListener('click', openSizeGuide); });
  if (sg) {
    sg.addEventListener('click', function (e) { if (e.target === sg) closeSizeGuide(); });
    var sgClose = sg.querySelector('[data-close-sizeguide]');
    if (sgClose) sgClose.addEventListener('click', closeSizeGuide);
  }
  if (sg && window.location.hash === '#size-guide') openSizeGuide();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#size-guide"]');
    if (a && sg) { e.preventDefault(); openSizeGuide(); }
  });

  // ---------- Escape ----------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && !lightbox.hidden) closeLightbox();
    if (sg && !sg.hidden) closeSizeGuide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bed-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Variant changes from the hero update the sticky bar's label + price.
  document.addEventListener('gp:variantChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.title) {
      colorLabel.textContent = detail.title;
    }
    if (priceEl && typeof detail.priceCents === 'number') {
      priceEl.textContent = formatMoney(detail.priceCents);
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bed-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bowl-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bowl-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bowl-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var slideIndex = 0;
  var stage = section.querySelector('.gp-hero__stage');
  var priceEl = section.querySelector('[data-hero-price]');
  var variantInput = section.querySelector('[data-hero-variant-input]');
  var ctaBtn = section.querySelector('[data-hero-cta]');
  var sizeSelected = section.querySelector('[data-size-selected]');

  function formatMoney(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function render() {
      slides.forEach(function (el, i) { el.classList.toggle('gp-hero__slide--active', i === slideIndex); });
      thumbs.forEach(function (el, i) { el.classList.toggle('gp-hero__thumb--active', i === slideIndex); });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex - 1 + slides.length) % slides.length; render(); } };
    if (nextBtn) nextBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex + 1) % slides.length; render(); } };
    thumbs.forEach(function (el, i) { el.onclick = function () { slideIndex = i; render(); }; });
    render();
  }
  bindGallery();

  // ---------- Variant selector ----------
  var defaultCtaLabel = ctaBtn ? ctaBtn.textContent.trim() : 'Add to Cart';
  function selectSize(btn) {
    if (btn.getAttribute('data-variant-available') !== 'true') return;
    section.querySelectorAll('.gp-hero__size-btn').forEach(function (el) {
      var on = el === btn;
      el.classList.toggle('gp-hero__size-btn--active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-variant-title');
    var price = parseInt(btn.getAttribute('data-variant-price'), 10);
    if (variantInput) variantInput.value = id;
    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    if (sizeSelected) sizeSelected.textContent = ' · ' + title;
    if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.textContent = defaultCtaLabel; }
    document.dispatchEvent(new CustomEvent('gp:variantChanged', {
      detail: { variantId: id, title: title, priceCents: isNaN(price) ? null : price, available: true }
    }));
  }
  section.querySelectorAll('.gp-hero__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { selectSize(btn); });
  });

  // ---------- Quantity ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');
  function setQty(n) { var v = parseInt(n, 10); if (isNaN(v) || v < 1) v = 1; if (qtyInput) qtyInput.value = v; }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) { qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); }); }

  // ---------- Cross-promo add to cart ----------
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
  };
  function transientAdded(btn) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added';
    btn.dataset.added = '1';
  }
  section.querySelectorAll('[data-xsell-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.added === '1') return;
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      window.GP_ADD_TO_CART([{ id: id, quantity: 1 }])
        .then(function () { transientAdded(btn); })
        .catch(function () { transientAdded(btn); });
    });
  });

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '').replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi; lightboxImg.alt = alt || '';
    lightbox.hidden = false; lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open'); lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) stage.addEventListener('click', function (e) {
    var img = e.target.closest('.gp-hero__photo');
    if (img) { e.preventDefault(); openLightbox(img.src, img.alt); }
  });
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target === lightboxImg) closeLightbox(); });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  // ---------- Size-guide modal ----------
  var sg = section.querySelector('[data-sizeguide]');
  function openSizeGuide() { if (!sg) return; sg.hidden = false; sg.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeSizeGuide() { if (!sg) return; sg.classList.remove('is-open'); sg.hidden = true; document.documentElement.style.overflow = ''; }
  section.querySelectorAll('[data-open-sizeguide]').forEach(function (b) { b.addEventListener('click', openSizeGuide); });
  if (sg) {
    sg.addEventListener('click', function (e) { if (e.target === sg) closeSizeGuide(); });
    var sgClose = sg.querySelector('[data-close-sizeguide]');
    if (sgClose) sgClose.addEventListener('click', closeSizeGuide);
  }
  if (sg && window.location.hash === '#size-guide') openSizeGuide();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#size-guide"]');
    if (a && sg) { e.preventDefault(); openSizeGuide(); }
  });

  // ---------- Color swatches: AJAX product swap (matches leash/collar PDPs) ----------
  var titleEl = section.querySelector('.gp-hero__title');
  var sizesWrap = section.querySelector('.gp-hero__sizes');
  var thumbsWrap = section.querySelector('.gp-hero__thumbs');
  var colorsSelected = section.querySelector('[data-colors-selected]');

  function currentSizeTitle() {
    var a = section.querySelector('.gp-hero__size-btn--active');
    return a ? a.getAttribute('data-variant-title') : null;
  }
  function bindSizeButtons() {
    section.querySelectorAll('.gp-hero__size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectSize(btn); });
    });
  }
  function rebuildSizes(pj, preferTitle) {
    if (!pj || !pj.variants || !pj.variants.length) return;
    var variants = pj.variants;
    var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ''); };
    var want = norm(preferTitle);
    var target = null;
    variants.forEach(function (v) { if (!target && want && norm(v.title) === want && v.available) target = v; });
    if (!target) { for (var i = 0; i < variants.length; i++) { if (variants[i].available) { target = variants[i]; break; } } }
    if (!target) target = variants[0];
    if (sizesWrap) {
      sizesWrap.innerHTML = '';
      variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gp-hero__size-btn' + (v.id === target.id ? ' gp-hero__size-btn--active' : '') + (v.available ? '' : ' gp-hero__size-btn--soldout');
        btn.setAttribute('data-variant-id', String(v.id));
        btn.setAttribute('data-variant-title', v.title);
        btn.setAttribute('data-variant-price', String(v.price));
        btn.setAttribute('data-variant-available', v.available ? 'true' : 'false');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', v.id === target.id ? 'true' : 'false');
        btn.appendChild(document.createTextNode(v.title));
        if (!v.available) { var f = document.createElement('span'); f.className = 'gp-hero__size-btn-flag'; f.textContent = ' Sold out'; btn.appendChild(f); }
        sizesWrap.appendChild(btn);
      });
      bindSizeButtons();
    }
    if (variantInput) variantInput.value = String(target.id);
    if (priceEl) priceEl.textContent = formatMoney(target.price);
    if (sizeSelected) sizeSelected.textContent = ' · ' + target.title;
    if (ctaBtn) { ctaBtn.disabled = !target.available; ctaBtn.textContent = target.available ? defaultCtaLabel : 'Sold out'; }
  }
  function rebuildGallery(images) {
    if (!stage || !thumbsWrap || !images || !images.length) return;
    var arrows = stage.querySelectorAll('.gp-hero__arrow');
    Array.prototype.slice.call(stage.querySelectorAll('.gp-hero__slide')).forEach(function (n) { n.remove(); });
    thumbsWrap.innerHTML = '';
    var max = Math.min(images.length, 6);
    for (var i = 0; i < max; i++) {
      var src = images[i];
      var slide = document.createElement('div');
      slide.className = 'gp-hero__slide' + (i === 0 ? ' gp-hero__slide--active' : '');
      slide.setAttribute('data-slide-index', String(i));
      var img = document.createElement('img');
      img.className = 'gp-hero__photo';
      img.src = src + (src.indexOf('?') === -1 ? '?width=900' : '&width=900');
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.alt = '';
      slide.appendChild(img);
      stage.insertBefore(slide, arrows[0] || null);
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'gp-hero__thumb' + (i === 0 ? ' gp-hero__thumb--active' : '');
      thumb.setAttribute('data-thumb-index', String(i));
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));
      var t = document.createElement('img');
      t.className = 'gp-hero__thumb-photo';
      t.src = src + (src.indexOf('?') === -1 ? '?width=160' : '&width=160');
      t.loading = 'lazy';
      t.alt = '';
      thumb.appendChild(t);
      thumbsWrap.appendChild(thumb);
    }
    slideIndex = 0;
    bindGallery();
  }
  function applySwatch(swatch) {
    var handle = swatch.getAttribute('data-pdp-handle');
    var label = swatch.getAttribute('data-color-label');
    var url = swatch.getAttribute('data-pdp-url');
    if (!handle) return;
    section.querySelectorAll('.gp-hero__swatch').forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (colorsSelected && label) colorsSelected.textContent = label;
    if (url) { try { history.replaceState({}, '', url); } catch (e) { /* noop */ } }
    var prefer = currentSizeTitle();
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pj) {
        if (!pj) return;
        if (titleEl) titleEl.textContent = pj.title;
        rebuildGallery(pj.images && pj.images.length ? pj.images : (pj.featured_image ? [pj.featured_image] : []));
        rebuildSizes(pj, prefer);
      })
      .catch(function () {});
  }
  section.querySelectorAll('.gp-hero__swatch').forEach(function (sw) {
    sw.addEventListener('click', function () { applySwatch(sw); });
  });

  // ---------- Escape ----------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && !lightbox.hidden) closeLightbox();
    if (sg && !sg.hidden) closeSizeGuide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bowl-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Variant changes from the hero update the sticky bar's label + price.
  document.addEventListener('gp:variantChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.title) {
      colorLabel.textContent = detail.title;
    }
    if (priceEl && typeof detail.priceCents === 'number') {
      priceEl.textContent = formatMoney(detail.priceCents);
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-bowl-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-hero"] && !Shopify.designMode) return;
  try {
    
/* gp-collar-hero build 2026-06-24d — swatch binds main buy box to the COLLAR (pdpHandle) only; paired leash lives in the cross-sell. type-guarded. cache-bust */
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var collarColorManual = false;
  var slideIndex = 0;
  try { if (!window.__gpHeroBuild) { window.__gpHeroBuild = 'collar-2026-06-24d'; if (window.console) console.log('[GlowPups] collar-hero JS build collar-2026-06-24d'); } } catch (e) {}

  // Defensive guard: this section is the COLLAR PDP, so the main buy box must never paint a
  // non-collar product. gpTypeOk() lets a future handle-wiring regression (or stale paired data)
  // fall back to the correct server-rendered product instead of cross-painting a leash.
  var gpExpectType = section.getAttribute('data-gp-pdp-type') || 'collar';
  function gpTypeOk(json) {
    if (!json || !gpExpectType) return true;
    var t = ((json.type || '') + ' ' + (json.title || '')).toLowerCase();
    // Bail ONLY when the fetched product is POSITIVELY the opposite type — never on mere absence
    // of the expected keyword — so a correctly-typed product is never suppressed (no false-negative).
    if (gpExpectType === 'collar') return t.indexOf('leash') === -1;
    if (gpExpectType === 'leash') return t.indexOf('collar') === -1;
    return true;
  }

  // ---------- DOM refs ----------
  var stage = section.querySelector('.gp-hero__stage');
  var thumbsWrap = section.querySelector('.gp-hero__thumbs');
  var titleEl = section.querySelector('.gp-hero__title');
  var priceEl = section.querySelector('.gp-hero__price');
  var subEl = section.querySelector('.gp-hero__sub');
  var selectedLabel = section.querySelector('.gp-hero__colors-selected');
  var formIdInput = section.querySelector('.gp-hero__form input[name="id"]');
  var ctaBtn = section.querySelector('.gp-hero__cta');
  var collarLabel = section.querySelector('.gp-hero__collar-dot-label');
  var collarSize = section.querySelector('.gp-hero__collar-size');
  var collarAdd = section.querySelector('.gp-hero__collar-add');
  var collarUpsell = section.querySelector('.gp-hero__upsell');
  var collarTitle = section.querySelector('.gp-hero__upsell-collar-title');
  var collarThumb = section.querySelector('.gp-hero__upsell-thumb-photo');
  var collarThumbWrap = section.querySelector('.gp-hero__upsell-thumb');

  // ---------- Helpers ----------
  function getSwatches() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__swatch'));
  }
  function getCollarDots() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__collar-dot'));
  }
  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function renderGallery() {
      slides.forEach(function (el, i) {
        el.classList.toggle('gp-hero__slide--active', i === slideIndex);
      });
      thumbs.forEach(function (el, i) {
        el.classList.toggle('gp-hero__thumb--active', i === slideIndex);
      });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex - 1 + slides.length) % slides.length;
      renderGallery();
    };
    if (nextBtn) nextBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex + 1) % slides.length;
      renderGallery();
    };
    thumbs.forEach(function (el, i) {
      el.onclick = function () { slideIndex = i; renderGallery(); };
    });
    renderGallery();
  }
  bindGallery();

  function rebuildGallery(images) {
    if (!stage || !thumbsWrap || !images || !images.length) return;
    var arrows = stage.querySelectorAll('.gp-hero__arrow');
    // Clear out existing slides (keep arrows)
    Array.prototype.slice.call(stage.querySelectorAll('.gp-hero__slide')).forEach(function (n) { n.remove(); });
    thumbsWrap.innerHTML = '';
    var max = Math.min(images.length, 5);
    for (var i = 0; i < max; i++) {
      var src = images[i];
      var fullUrl = src.indexOf('//') === 0 ? src : (src.indexOf('http') === 0 ? src : src);
      // Build slide
      var slide = document.createElement('div');
      slide.className = 'gp-hero__slide' + (i === 0 ? ' gp-hero__slide--active' : '');
      slide.setAttribute('data-slide-index', String(i));
      var img = document.createElement('img');
      img.className = 'gp-hero__photo';
      img.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=900' : '&width=900');
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.alt = '';
      slide.appendChild(img);
      // Insert before arrows so arrows stay on top
      stage.insertBefore(slide, arrows[0] || null);
      // Build thumb
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'gp-hero__thumb' + (i === 0 ? ' gp-hero__thumb--active' : '');
      thumb.setAttribute('data-thumb-index', String(i));
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));
      var tImg = document.createElement('img');
      tImg.className = 'gp-hero__thumb-photo';
      tImg.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=160' : '&width=160');
      tImg.loading = 'lazy';
      tImg.alt = '';
      thumb.appendChild(tImg);
      thumbsWrap.appendChild(thumb);
    }
    slideIndex = 0;
    bindGallery();
  }

  // ---------- Paired-leash size rebuild (called rebuildCollarSizes for legacy back-compat) ----------
  // On collar PDP the paired-product dropdown holds the LEASH's variants (typically a single variant).
  // Written defensively in case a leash product is ever variant-ed.
  function rebuildLeashSizesFromJson(leashJson) {
    if (!leashJson || !leashJson.variants || !leashJson.variants.length) return;
    // Leashes have no size variants, so there's no <select> to rebuild — track the paired-leash
    // variant id + price on the bundle button / upsell from the first available variant.
    var firstAvail = null;
    for (var i = 0; i < leashJson.variants.length; i++) {
      if (leashJson.variants[i].available) { firstAvail = leashJson.variants[i]; break; }
    }
    var leashVariant = firstAvail || leashJson.variants[0];
    if (collarAdd) {
      collarAdd.setAttribute('data-collar-variant-id', String(leashVariant.id));
      collarAdd.setAttribute('data-paired-variant-id', String(leashVariant.id));
    }
    if (collarUpsell) collarUpsell.setAttribute('data-collar-price-cents', String(leashVariant.price));
    // Defensive: if a leash ever becomes variant-ed and the <select> is restored, keep it in sync.
    if (collarSize) {
      var current = collarSize.value;
      collarSize.innerHTML = '';
      var firstAvailableId = null;
      leashJson.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = String(v.id);
        opt.setAttribute('data-variant-price', String(v.price));
        opt.textContent = v.title + (v.available ? '' : ' — sold out');
        if (!v.available) opt.disabled = true;
        if (firstAvailableId === null && v.available) firstAvailableId = String(v.id);
        collarSize.appendChild(opt);
      });
      var matched = false;
      Array.prototype.slice.call(collarSize.options).forEach(function (o) {
        if (!matched && o.value === current && !o.disabled) { o.selected = true; matched = true; }
      });
      if (!matched && firstAvailableId) collarSize.value = firstAvailableId;
      if (collarAdd) collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
    }
    updateBundlePricing();
  }
  // Legacy alias — downstream calls in this file still use the old name.
  var rebuildCollarSizes = rebuildLeashSizesFromJson;

  // ---------- Bundle pricing (subtotal row + CTA label) ----------
  var bundleEls = {
    upsell: section.querySelector('.gp-hero__upsell'),
    strike: section.querySelector('[data-bundle-strike]'),
    total: section.querySelector('[data-bundle-total]'),
    savingsPill: section.querySelector('[data-bundle-savings]'),
    addLabel: section.querySelector('[data-collar-add-label]')
  };
  function getSelectedCollarCents() {
    if (!collarSize || !collarSize.selectedOptions || !collarSize.selectedOptions[0]) return null;
    var raw = collarSize.selectedOptions[0].getAttribute('data-variant-price');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }
  function updateBundlePricing() {
    if (!bundleEls.upsell) return;
    var leashCents = parseInt(bundleEls.upsell.getAttribute('data-leash-price-cents'), 10);
    if (isNaN(leashCents)) leashCents = 0;
    var collarCents = getSelectedCollarCents();
    if (collarCents == null) {
      var fallback = parseInt(bundleEls.upsell.getAttribute('data-collar-price-cents'), 10);
      collarCents = isNaN(fallback) ? 0 : fallback;
    } else {
      bundleEls.upsell.setAttribute('data-collar-price-cents', String(collarCents));
    }
    var savingsCents = parseInt(bundleEls.upsell.getAttribute('data-bundle-savings-cents'), 10);
    if (isNaN(savingsCents)) savingsCents = 0;
    var fullTotal = leashCents + collarCents;
    var bundleTotal = Math.max(0, fullTotal - savingsCents);
    if (bundleEls.strike) bundleEls.strike.textContent = formatMoney(fullTotal);
    if (bundleEls.total) bundleEls.total.textContent = formatMoney(bundleTotal);
    if (bundleEls.savingsPill) bundleEls.savingsPill.textContent = 'Save ' + formatMoney(savingsCents).replace(/\.00$/, '');
    if (bundleEls.addLabel && collarAdd) {
      var base = collarAdd.getAttribute('data-collar-add-label') || 'Add to bundle';
      bundleEls.addLabel.textContent = base + ' — ' + formatMoney(bundleTotal);
    }
  }
  // ---------- Option picker (added 2026-09-24) ----------
  var gpOptWrap = section.querySelector('[data-gp-options]');
  var gpOptState = null;
  function gpOptNames(pj) {
    return (pj.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }
  function gpApplyVariant(v) {
    if (!v) return;
    var id = String(v.id);
    if (formIdInput) formIdInput.value = id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    var strike = section.querySelector('.gp-hero__price-strike');
    if (strike) { var cmp = v.compare_at_price || 0; strike.style.display = cmp > v.price ? '' : 'none'; if (cmp > v.price) strike.textContent = formatMoney(cmp); }
    if (ctaBtn) {
      if (!ctaBtn.dataset.defaultLabel) ctaBtn.dataset.defaultLabel = ctaBtn.textContent.trim() || 'Add to Cart';
      ctaBtn.disabled = !v.available;
      ctaBtn.textContent = v.available ? ctaBtn.dataset.defaultLabel : 'Sold out';
    }
    var addBtn = section.querySelector('.gp-hero__collar-add');
    if (addBtn) addBtn.setAttribute('data-pdp-variant-id', id);
    setLeashPriceCents(v.price);
    var stickyPrice = document.querySelector('[data-section-type="gp-sticky"] .gp-sticky__price');
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    try { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); } catch (err) { /* noop */ }
  }
  function gpFind(pj, sel) {
    for (var i = 0; i < pj.variants.length; i++) {
      var ok = true;
      for (var k = 0; k < sel.length; k++) { if (pj.variants[i].options[k] !== sel[k]) { ok = false; break; } }
      if (ok) return pj.variants[i];
    }
    return null;
  }
  function gpDraw() {
    var st = gpOptState, pj = st.pj, names = gpOptNames(pj), html = '';
    for (var k = 0; k < names.length; k++) {
      var seen = {}, vals = [];
      pj.variants.forEach(function (v) {
        for (var j = 0; j < k; j++) { if (v.options[j] !== st.sel[j]) return; }
        var val = v.options[k];
        if (!seen[val]) { seen[val] = { avail: false }; vals.push(val); }
        if (v.available) seen[val].avail = true;
      });
      html += '<div class="gp-hero__opt"><span class="gp-hero__colors-label">' + gpEsc(names[k]) + ': <em>' + gpEsc(st.sel[k]) + '</em></span><div class="gp-hero__size-list" role="radiogroup" aria-label="' + gpEsc(names[k]) + '">';
      vals.forEach(function (val) {
        var on = val === st.sel[k];
        html += '<button type="button" class="gp-hero__size-btn' + (on ? ' is-active' : '') + (seen[val].avail ? '' : ' is-soldout') + '" role="radio" aria-checked="' + on + '" data-opt="' + k + '" data-val="' + gpEsc(val) + '"' + (seen[val].avail ? '' : ' aria-label="' + gpEsc(val) + ' — sold out"') + '>' + gpEsc(val) + '</button>';
      });
      html += '</div></div>';
    }
    gpOptWrap.innerHTML = html;
  }
  function gpEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function gpSelect(k, val) {
    var st = gpOptState, pj = st.pj, sel = st.sel.slice(0, k); sel[k] = val;
    var n = gpOptNames(pj).length;
    // keep later choices when that combination exists; otherwise fall back to the first available match
    var keep = st.sel.slice(0, n); keep[k] = val; for (var j = 0; j < k; j++) keep[j] = sel[j];
    var v = gpFind(pj, keep);
    if (!v || !v.available) {
      var best = null;
      pj.variants.forEach(function (x) {
        for (var j = 0; j <= k; j++) { if (x.options[j] !== sel[j]) return; }
        if (!best || (!best.available && x.available)) best = x;
      });
      if (!v || (best && best.available)) v = best;
    }
    if (!v) return;
    st.sel = v.options.slice(0, n);
    gpDraw(); gpApplyVariant(v);
  }
  function gpRenderOptions(pj, preferId) {
    if (!gpOptWrap || !pj || !pj.variants || !pj.variants.length) return;
    var names = gpOptNames(pj);
    if (pj.variants.length === 1 && names.length <= 1 && (pj.variants[0].title === 'Default Title')) { gpOptWrap.innerHTML = ''; gpOptState = null; return; }
    var v = null, prev = gpOptState;
    if (preferId) pj.variants.forEach(function (x) { if (String(x.id) === String(preferId)) v = x; });
    if (!v && prev) {
      // carry the shopper's choice (e.g. size) across a swatch swap when the new product has it
      pj.variants.forEach(function (x) {
        if (v) return;
        var ok = x.available;
        prev.sel.forEach(function (val, k) { var nm = names[k]; var pk = gpOptNames(prev.pj).indexOf(nm); if (nm && pk > -1 && x.options[k] !== prev.sel[pk]) ok = false; });
        if (ok) v = x;
      });
    }
    if (!v) pj.variants.forEach(function (x) { if (!v && x.available) v = x; });
    if (!v) v = pj.variants[0];
    gpOptState = { pj: pj, sel: v.options.slice(0, names.length) };
    gpDraw();
    if (prev) gpApplyVariant(v);
  }
  if (gpOptWrap) {
    gpOptWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.gp-hero__size-btn');
      if (!b || !gpOptState) return;
      gpSelect(parseInt(b.getAttribute('data-opt'), 10), b.getAttribute('data-val'));
    });
    try {
      var gpInit = JSON.parse(section.querySelector('[data-gp-product-json]').textContent);
      gpRenderOptions(gpInit, gpOptWrap.getAttribute('data-initial-variant'));
    } catch (err) { /* noop */ }
  }

  function setLeashPriceCents(cents) {
    if (!bundleEls.upsell || cents == null) return;
    bundleEls.upsell.setAttribute('data-leash-price-cents', String(cents));
    updateBundlePricing();
  }

  // ---------- Apply color swatch: AJAX swap (collar PDP) ----------
  // On collar PDP: the CURRENT product is a collar, the PAIRED product is a leash.
  // Function name retained as `applyLeashSwatch` for back-compat with the existing wiring below.
  function applyLeashSwatch(swatch) {
    // Prefer the new unambiguous attrs (data-pdp-*, data-paired-*).
    // Fall back to legacy attrs where on collar PDP:
    //   dataset.collarHandle == CURRENT collar handle
    //   dataset.leashHandle  == PAIRED leash handle
    var pdpHandle = swatch.dataset.pdpHandle || swatch.dataset.collarHandle;
    var pairedHandle = swatch.dataset.pairedHandle || swatch.dataset.leashHandle;
    var label = swatch.dataset.colorLabel;
    var url = swatch.dataset.pdpUrl || swatch.dataset.collarUrl || swatch.dataset.leashUrl;

    // Optimistic UI
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;
    if (url) {
      try { history.replaceState({}, '', url); } catch (err) { /* noop */ }
    }

    if (!pdpHandle) return;

    // Race guard: only the LATEST swatch's response may paint the buy box / sync other sections.
    // Stale, out-of-order /products/*.js responses from rapid clicking are dropped — this is what
    // prevents the title/label/swatch "musical chairs" desync.
    var reqToken = (section.__gpReq = (section.__gpReq || 0) + 1);

    // Fetch CURRENT (collar) + PAIRED (leash) in parallel.
    // Order: [pdpPromise, pairedPromise] === [collarPromise, leashPromise] on a collar PDP.
    var pdpPromise = fetch('/products/' + pdpHandle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    var pairedPromise = pairedHandle
      ? fetch('/products/' + pairedHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([pdpPromise, pairedPromise]).then(function (results) {
      if (reqToken !== section.__gpReq) return; // a newer swatch was clicked — drop this stale response
      var pdpJson = results[0];       // current product (collar)
      var pairedJson = results[1];    // paired product (leash)
      var collarJson = pdpJson;       // legacy alias: on collar PDP current = collar
      var leashJson = pairedJson;     // legacy alias: on collar PDP paired = leash

      // ---- Current product side (collar) — drives title/price/gallery/hidden ATC form ----
      if (pdpJson && gpTypeOk(pdpJson)) {
        var firstAvail = null;
        for (var i = 0; i < pdpJson.variants.length; i++) {
          if (pdpJson.variants[i].available) { firstAvail = pdpJson.variants[i]; break; }
        }
        var pdpVariant = firstAvail || pdpJson.variants[0];
        if (titleEl) titleEl.textContent = pdpJson.title;
        if (priceEl) priceEl.textContent = formatMoney(pdpVariant.price);
        if (formIdInput) formIdInput.value = String(pdpVariant.id);
        setLeashPriceCents(pdpVariant.price); // legacy fn name; updates data-leash-price-cents == PDP cents
        if (ctaBtn) {
          ctaBtn.disabled = !pdpVariant.available;
          ctaBtn.textContent = pdpVariant.available
            ? (ctaBtn.dataset.defaultLabel || ctaBtn.textContent || 'Add to Cart')
            : 'Sold out';
        }
        gpRenderOptions(pdpJson);
        rebuildGallery(pdpJson.images || (pdpJson.featured_image ? [pdpJson.featured_image] : []));
      }

      // ---- Paired product side (leash) — drives the upsell callout below the ATC ----
      if (!collarColorManual && collarUpsell) {
        if (pairedJson) {
          if (collarTitle) collarTitle.textContent = pairedJson.title;
          if (collarThumb && pairedJson.featured_image) {
            collarThumb.src = pairedJson.featured_image + (pairedJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
            collarThumb.alt = pairedJson.title;
          } else if (!collarThumb && collarThumbWrap && pairedJson.featured_image) {
            collarThumbWrap.innerHTML = '<img class="gp-hero__upsell-thumb-photo" src="' + pairedJson.featured_image + '?width=240" alt="" loading="lazy" width="120" height="120">';
            collarThumb = collarThumbWrap.querySelector('.gp-hero__upsell-thumb-photo');
          }
          rebuildLeashSizesFromJson(pairedJson);
          // Back-compat dataset keys + new unambiguous keys on the upsell container.
          collarUpsell.dataset.collarHandle = pairedJson.handle;
          collarUpsell.dataset.collarProductId = String(pairedJson.id);
          collarUpsell.dataset.pairedHandle = pairedJson.handle;
          collarUpsell.dataset.pairedProductId = String(pairedJson.id);
          // Mirror dot active state — match either new paired attr or legacy collar attr.
          getCollarDots().forEach(function (el) {
            var dotPaired = el.dataset.pairedHandle || el.dataset.collarHandle;
            var on = dotPaired === pairedJson.handle;
            el.classList.toggle('gp-hero__collar-dot--active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (collarLabel) collarLabel.textContent = label;
        }
      }

      // Cross-section sync (matched-set, sticky-atc).
      // On collar PDP:
      //   handle / variantId  == current (collar)
      //   collarHandle / collarJson == current (collar)  [back-compat — listeners that read these now get the collar]
      //   leashHandle / leashJson   == paired  (leash)   [back-compat — listeners that read these now get the leash]
      //   pdpJson / pairedJson      == unambiguous; downstream listeners should prefer these
      document.dispatchEvent(new CustomEvent('gp:colorChanged', {
        detail: {
          colorId: pdpHandle,
          label: label,
          handle: pdpHandle,
          variantId: pdpJson && pdpJson.variants[0] ? pdpJson.variants[0].id : null,
          // Current (collar)
          collarHandle: pdpHandle,
          collarJson: pdpJson,
          collarImage: pdpJson && pdpJson.featured_image ? pdpJson.featured_image : null,
          collarPrice: pdpJson && pdpJson.variants[0] ? pdpJson.variants[0].price : null,
          collarTitle: pdpJson ? pdpJson.title : null,
          // Paired (leash)
          leashHandle: pairedHandle || null,
          leashJson: pairedJson,
          leashImage: pairedJson && pairedJson.featured_image ? pairedJson.featured_image : null,
          leashPrice: pairedJson && pairedJson.variants[0] ? pairedJson.variants[0].price : null,
          leashTitle: pairedJson ? pairedJson.title : null,
          // Unambiguous
          pdpHandle: pdpHandle,
          pdpJson: pdpJson,
          pairedHandle: pairedHandle || null,
          pairedJson: pairedJson,
          source: 'collar-hero'
        }
      }));
    });
  }

  // Hex-fill (fallback) handler — legacy behavior when no collection is set
  function applyLeashHexSwatch(swatch) {
    var id = swatch.dataset.colorId;
    var label = swatch.dataset.colorLabel;
    var hex = swatch.dataset.colorHex;
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;
    slideIndex = 0;
    bindGallery();
    if (!collarColorManual) {
      getCollarDots().forEach(function (el) {
        var on = el.dataset.collarColor === id;
        el.classList.toggle('gp-hero__collar-dot--active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = label;
    }
    document.dispatchEvent(new CustomEvent('gp:colorChanged', {
      detail: { colorId: id, label: label, hex: hex }
    }));
  }

  // Color swatches are now plain <a> links to each color's collar product page (server-rendered).
  // No JS swatch-click handler and no cross-section gp:colorChanged main-product swap — picking a
  // color NAVIGATES, so the buy box + add-to-cart are always the correct server-rendered product
  // (immune to the theme editor's stale section-JS cache).

  // ---------- Quantity stepper ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');

  function setQty(n) {
    var val = parseInt(n, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (qtyInput) qtyInput.value = val;
  }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () { if (qtyInput.value !== '') setQty(qtyInput.value); });
    qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); });
  }

  // ---------- Paired-leash color manual override (legacy: "collar color manual") ----------
  // On collar PDP, the dots inside the upsell now represent leash colors. The user can pick
  // a different leash without changing the main PDP color.
  getCollarDots().forEach(function (el) {
    el.addEventListener('click', function () {
      collarColorManual = true;
      getCollarDots().forEach(function (d) {
        var on = d === el;
        d.classList.toggle('gp-hero__collar-dot--active', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = el.dataset.collarLabel || '';
      // If this dot points at a different paired (leash) product, fetch its variants and swap.
      // Back-compat: data-collar-handle now carries the PAIRED leash handle on collar PDP.
      var pairedHandle = el.dataset.pairedHandle || el.dataset.collarHandle;
      if (pairedHandle) {
        fetch('/products/' + pairedHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (pairedJson) {
            if (!pairedJson || !collarUpsell) return;
            if (collarTitle) collarTitle.textContent = pairedJson.title;
            if (collarThumb && pairedJson.featured_image) {
              collarThumb.src = pairedJson.featured_image + (pairedJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
              collarThumb.alt = pairedJson.title;
            }
            rebuildLeashSizesFromJson(pairedJson);
            collarUpsell.dataset.collarHandle = pairedJson.handle;
            collarUpsell.dataset.collarProductId = String(pairedJson.id);
            collarUpsell.dataset.pairedHandle = pairedJson.handle;
            collarUpsell.dataset.pairedProductId = String(pairedJson.id);
          })
          .catch(function () { /* noop */ });
      }
    });
  });

  // ---------- Collar size change ----------
  if (collarSize && collarAdd) {
    collarSize.addEventListener('change', function () {
      collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
      updateBundlePricing();
      resetAdded(collarAdd);
    });
  }

  // ---------- Add-to-cart helper + collar add ----------
  function transientAdded(btn, addedHTML, ms) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = addedHTML;
    btn.dataset.added = '1';
  }
  function resetAdded(btn) {
    if (!btn || btn.dataset.added !== '1') return;
    if (btn.dataset.defaultHtml) btn.innerHTML = btn.dataset.defaultHtml;
    btn.dataset.added = '';
  }
  // Reset the bundle "Added" state when the selection changes (collar color / leash dot),
  // so the button never stays "Added" for a product the user is no longer adding.
  section.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.gp-hero__swatch, .gp-hero__collar-dot')) resetAdded(collarAdd);
  });
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  };

  if (collarAdd) {
    collarAdd.addEventListener('click', function () {
      if (collarAdd.dataset.added === '1') return;
      var addedHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added to bundle ✓';
      // Bundle = this PDP's product (collar) + the paired product (leash). Add BOTH in one request.
      var items = [];
      var collarVar = parseInt(collarAdd.dataset.pdpVariantId, 10);
      if (collarVar) items.push({ id: collarVar, quantity: 1 });
      var leashVar = parseInt(collarAdd.dataset.pairedVariantId || collarAdd.dataset.collarVariantId, 10);
      if (leashVar) items.push({ id: leashVar, quantity: 1 });
      if (items.length) {
        window.GP_ADD_TO_CART(items)
          .then(function () { transientAdded(collarAdd, addedHTML); })
          .catch(function () { transientAdded(collarAdd, addedHTML); });
      } else {
        transientAdded(collarAdd, addedHTML);
      }
    });
  }

  // Cache the CTA's original label so we can restore it after a sold-out state.
  if (ctaBtn && !ctaBtn.dataset.defaultLabel) {
    ctaBtn.dataset.defaultLabel = ctaBtn.textContent.trim();
  }

  // Sync bundle pricing on init
  updateBundlePricing();

  // ---------- Show-more toggles (leash + collar) ----------
  function wireToggle(btnSelector, targetSelector, expandedLabel, collapsedLabel, labelSelector) {
    var btn = section.querySelector(btnSelector);
    if (!btn) return;
    var target = section.querySelector(targetSelector);
    if (!target) return;
    var labelEl = section.querySelector(labelSelector);
    // Restore the label THIS section's Liquid actually rendered (prevents any cross-section bleed, e.g. "toys").
    var restoreLabel = (labelEl && labelEl.textContent.trim()) ? labelEl.textContent.trim() : collapsedLabel;
    btn.addEventListener('click', function () {
      var collapsed = target.getAttribute('data-collapsed') === 'true';
      if (collapsed) {
        target.removeAttribute('data-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        if (labelEl) labelEl.textContent = expandedLabel;
      } else {
        target.setAttribute('data-collapsed', 'true');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = restoreLabel;
      }
    });
  }
  var colorCount = section.querySelectorAll('.gp-hero__colors .gp-hero__swatch').length;
  var collarCount = section.querySelectorAll('.gp-hero__collar-dots .gp-hero__collar-dot').length;
  wireToggle('[data-toggle-colors]', '.gp-hero__colors', 'Show fewer', 'Show all ' + colorCount + ' colors', '[data-toggle-colors-label]');
  wireToggle('[data-toggle-collar-dots]', '.gp-hero__collar-dots', 'Show fewer', 'Show all ' + collarCount + ' leashes', '[data-toggle-collar-dots-label]');

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src;
    // Strip Shopify width suffix to get max-resolution image
    hi = hi.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '');
    // If the URL has _900x etc transformations, strip them
    hi = hi.replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) {
    stage.addEventListener('click', function (e) {
      var img = e.target.closest('.gp-hero__photo');
      if (img) {
        e.preventDefault();
        openLightbox(img.src, img.alt);
      }
    });
  }
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-matched-set"] && !Shopify.designMode) return;
  try {
    
/*
  Collar PDP Matched Set — inverted pairing logic.
    - CURRENT product = collar (this PDP)
    - PAIRED product  = leash (resolved from product.metafields.custom.matching_leash)

  Hero dependency (read carefully before editing):
    The collar hero (glowpups-collar-hero.liquid) is currently a clone of the
    leash hero. Its `gp:colorChanged` event payload still uses leash-PDP key
    names — i.e. on the collar PDP it emits `collarHandle/collarJson/collarImage`
    where those actually describe the CURRENT collar (not the paired product).
    It may not yet emit `leashHandle/leashJson/leashImage` for the paired leash.

    To stay tolerant of both shapes, the gp:colorChanged listener below reads
    whichever of `detail.leashJson` or `detail.collarJson` is present and treats
    it as the PAIRED product data. The hero will be updated in a follow-up task
    to dispatch `leashJson/leashHandle/leashImage` (paired) properly.
*/
document.querySelectorAll('[data-section-type="gp-set"]').forEach(function (section) {
  var dots = Array.prototype.slice.call(section.querySelectorAll('.gp-set__dot'));
  var colorLabel = section.querySelector('[data-set-color-label]');
  var collarImg = section.querySelector('[data-set-collar-img]');
  var leashImg = section.querySelector('[data-set-leash-img]');
  var leashSize = section.querySelector('[data-leash-size]');
  var addBtn = section.querySelector('[data-set-add]');
  var priceRow = section.querySelector('.gp-set__price-row');
  var strikeEl = section.querySelector('[data-set-strike]');
  var totalEl = section.querySelector('[data-set-total]');
  var savingsEl = section.querySelector('[data-set-savings]');
  var addLabelEl = section.querySelector('[data-set-add-label]');

  function findActive() {
    return section.querySelector('.gp-set__dot--active') || dots[0];
  }
  var initialActive = findActive();
  var state = {
    colorId: initialActive ? (initialActive.dataset.collarHandle || initialActive.dataset.colorId) : null,
    leashSize: leashSize ? leashSize.value : null
  };

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }
  function getSelectedLeashCents() {
    if (!leashSize || !leashSize.selectedOptions || !leashSize.selectedOptions[0]) return null;
    var raw = leashSize.selectedOptions[0].getAttribute('data-variant-price');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }
  function updateSetPricing() {
    if (!priceRow) return;
    var collarCents = parseInt(priceRow.getAttribute('data-set-collar-cents'), 10);
    if (isNaN(collarCents)) collarCents = 0;
    var leashCents = getSelectedLeashCents();
    if (leashCents == null) {
      var fallback = parseInt(priceRow.getAttribute('data-set-leash-cents'), 10);
      leashCents = isNaN(fallback) ? 0 : fallback;
    } else {
      priceRow.setAttribute('data-set-leash-cents', String(leashCents));
    }
    var savingsCents = parseInt(priceRow.getAttribute('data-set-savings-cents'), 10);
    if (isNaN(savingsCents)) savingsCents = 0;
    var fullTotal = collarCents + leashCents;
    var bundleTotal = Math.max(0, fullTotal - savingsCents);
    if (strikeEl) strikeEl.textContent = formatMoney(fullTotal);
    if (totalEl) totalEl.textContent = formatMoney(bundleTotal);
    if (savingsEl) savingsEl.textContent = 'Save ' + formatMoney(savingsCents).replace(/\.00$/, '');
    if (addLabelEl) {
      var base = addLabelEl.getAttribute('data-base') || addLabelEl.textContent.replace(/\s*[—-]\s*\$.*$/, '').trim();
      if (!addLabelEl.getAttribute('data-base')) addLabelEl.setAttribute('data-base', base);
      addLabelEl.textContent = base + ' — ' + formatMoney(bundleTotal);
    }
  }
  function setCollarCents(cents) {
    if (!priceRow || cents == null) return;
    priceRow.setAttribute('data-set-collar-cents', String(cents));
    updateSetPricing();
  }

  function setActiveDotById(id) {
    dots.forEach(function (dot) {
      var dotId = dot.dataset.collarHandle || dot.dataset.colorId;
      var on = dotId === id;
      dot.classList.toggle('gp-set__dot--active', on);
      dot.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function applyLabel(label) {
    if (colorLabel) colorLabel.textContent = label + ' · matched throughout';
  }

  // Rebuilds the PAIRED (leash) size dropdown from a Shopify product JSON.
  function rebuildPairedSizesFromJson(leashJson) {
    if (!leashSize || !leashJson || !leashJson.variants) return;
    var current = leashSize.value;
    leashSize.innerHTML = '';
    var firstAvailableId = null;
    leashJson.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = v.title + (v.available ? '' : ' — sold out');
      if (!v.available) opt.disabled = true;
      if (firstAvailableId === null && v.available) firstAvailableId = String(v.id);
      leashSize.appendChild(opt);
    });
    var matched = false;
    Array.prototype.slice.call(leashSize.options).forEach(function (o) {
      if (!matched && o.value === current && !o.disabled) {
        o.selected = true;
        matched = true;
      }
    });
    if (!matched && firstAvailableId) leashSize.value = firstAvailableId;
    state.leashSize = leashSize.value;
    if (addBtn) addBtn.setAttribute('data-leash-variant', leashSize.value);
    // Re-stamp data-variant-price too (for the price reader)
    Array.prototype.slice.call(leashSize.options).forEach(function (o) {
      var v = leashJson.variants.filter(function (vv) { return String(vv.id) === o.value; })[0];
      if (v) o.setAttribute('data-variant-price', String(v.price));
    });
    updateSetPricing();
  }

  function applyDot(dot) {
    var id = dot.dataset.collarHandle || dot.dataset.colorId;
    var label = dot.dataset.colorLabel;
    state.colorId = id;
    setActiveDotById(id);
    applyLabel(label);
    // Stash collar price if the dot has one (image-swatch carries data-collar-variant-id; we'll read price from gp:colorChanged when collarJson lands)
    var collarVariantPrice = dot.getAttribute('data-collar-variant-price');
    if (collarVariantPrice) setCollarCents(parseInt(collarVariantPrice, 10));
    var collarImage = dot.dataset.collarImage;
    var leashImage = dot.dataset.leashImage;
    if (collarImg && collarImage) {
      if (collarImg.tagName === 'IMG') {
        collarImg.src = collarImage;
        collarImg.alt = label;
      }
    }
    if (leashImg && leashImage) {
      if (leashImg.tagName === 'IMG') {
        leashImg.src = leashImage;
        leashImg.alt = label;
      }
    }
    if (addBtn) {
      if (dot.dataset.collarVariantId) addBtn.setAttribute('data-collar-variant', dot.dataset.collarVariantId);
      if (dot.dataset.leashVariantId) addBtn.setAttribute('data-leash-variant', dot.dataset.leashVariantId);
    }
  }

  // Color dots are now plain <a> links to each color's collar page (server-rendered) — picking a
  // color NAVIGATES instead of swapping in place. No JS dot-click handler / gp:colorChanged dispatch.

  // React to color changes coming from other sections.
  document.addEventListener('gp:colorChanged', function (e) {
    if (!e.detail) return;
    var detail = e.detail;
    var incoming = detail.handle || detail.colorId;
    if (incoming === state.colorId) return;
    resetSetAdded(addBtn);
    // Find local dot that matches
    var target = null;
    for (var i = 0; i < dots.length; i++) {
      var dotId = dots[i].dataset.collarHandle || dots[i].dataset.colorId;
      if (dotId === incoming) { target = dots[i]; break; }
    }
    if (target) {
      applyDot(target);
    } else {
      // No matching dot — just sync the label
      state.colorId = incoming;
      if (detail.label) applyLabel(detail.label);
    }
    // Defensive fallback: prefer detail.leashJson (the paired product) but
    // fall back to detail.collarJson if the hero hasn't been refactored yet
    // and is still emitting the leash-PDP payload shape (where collarJson
    // historically meant "paired product json"). See top-of-file comment.
    var pairedJson = detail.leashJson || detail.collarJson;
    if (pairedJson) {
      rebuildPairedSizesFromJson(pairedJson);
    }
    if (typeof detail.collarPrice === 'number') {
      setCollarCents(detail.collarPrice);
    }
    if (collarImg && detail.collarImage && collarImg.tagName === 'IMG') {
      collarImg.src = detail.collarImage;
    }
    if (leashImg && detail.leashImage && leashImg.tagName === 'IMG') {
      leashImg.src = detail.leashImage;
    }
  });

  // Init pricing on load
  updateSetPricing();

  if (leashSize) {
    leashSize.addEventListener('change', function () {
      state.leashSize = leashSize.value;
      if (addBtn) addBtn.setAttribute('data-leash-variant', leashSize.value);
      updateSetPricing();
    });
  }

  // Add the Set
  function transientAdded(btn) {
    if (btn.dataset.added) return;
    var labelEl = btn.querySelector('[data-set-add-label]');
    if (!labelEl) return;
    if (!labelEl.dataset.defaultLabel) labelEl.dataset.defaultLabel = labelEl.textContent;
    labelEl.textContent = 'Set added ✓';
    btn.dataset.added = '1';
  }
  function resetSetAdded(btn) {
    if (!btn || !btn.dataset.added) return;
    var l = btn.querySelector('[data-set-add-label]');
    if (l && l.dataset.defaultLabel) l.textContent = l.dataset.defaultLabel;
    btn.dataset.added = '';
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.dataset.added) return;
      var collarVariant = addBtn.dataset.collarVariant;
      var leashVariant = addBtn.dataset.leashVariant;
      var items = [];
      if (collarVariant) items.push({ id: parseInt(collarVariant, 10), quantity: 1 });
      if (leashVariant) items.push({ id: parseInt(leashVariant, 10), quantity: 1 });
      if (items.length === 0) { transientAdded(addBtn); return; }
      var addFn = window.GP_ADD_TO_CART || function (i) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: i })
        });
      };
      addFn(items)
        .then(function () { transientAdded(addBtn); })
        .catch(function () { transientAdded(addBtn); });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  document.addEventListener('gp:colorChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.label) {
      colorLabel.textContent = detail.label;
    }
    // The sticky bar represents the CURRENT product (the collar on a collar PDP),
    // NOT the paired leash. Prefer the unambiguous pdpJson, then the collar* fields.
    var curPrice = (detail.pdpJson && detail.pdpJson.variants && detail.pdpJson.variants[0])
      ? detail.pdpJson.variants[0].price
      : (typeof detail.collarPrice === 'number' ? detail.collarPrice : null);
    if (priceEl) {
      if (typeof curPrice === 'number') {
        priceEl.textContent = formatMoney(curPrice);
      } else if (detail.price) {
        priceEl.textContent = detail.price;
      }
    }
    var curTitle = (detail.pdpJson && detail.pdpJson.title) || detail.collarTitle;
    if (titleEl && curTitle) {
      titleEl.textContent = curTitle;
    }
    var curImage = (detail.pdpJson && detail.pdpJson.featured_image) || detail.collarImage;
    if (curImage) {
      if (thumbImg) {
        thumbImg.src = curImage + (curImage.indexOf('?') === -1 ? '?width=80' : '&width=80');
      } else if (thumbWrap) {
        thumbWrap.innerHTML = '<img class="gp-sticky__img" src="' + curImage + '?width=80" loading="lazy" alt="">';
        thumbImg = thumbWrap.querySelector('.gp-sticky__img');
      }
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-collar-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-harness-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-harness-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-harness-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var slideIndex = 0;
  var stage = section.querySelector('.gp-hero__stage');
  var priceEl = section.querySelector('[data-hero-price]');
  var variantInput = section.querySelector('[data-hero-variant-input]');
  var ctaBtn = section.querySelector('[data-hero-cta]');
  var sizeSelected = section.querySelector('[data-size-selected]');

  function formatMoney(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function render() {
      slides.forEach(function (el, i) { el.classList.toggle('gp-hero__slide--active', i === slideIndex); });
      thumbs.forEach(function (el, i) { el.classList.toggle('gp-hero__thumb--active', i === slideIndex); });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex - 1 + slides.length) % slides.length; render(); } };
    if (nextBtn) nextBtn.onclick = function () { if (slides.length) { slideIndex = (slideIndex + 1) % slides.length; render(); } };
    thumbs.forEach(function (el, i) { el.onclick = function () { slideIndex = i; render(); }; });
    render();
  }
  bindGallery();

  // ---------- Size / variant selector ----------
  var defaultCtaLabel = ctaBtn ? ctaBtn.textContent.trim() : 'Add to Cart';
  function selectSize(btn) {
    if (btn.getAttribute('data-variant-available') !== 'true') return;
    section.querySelectorAll('.gp-hero__size-btn').forEach(function (el) {
      var on = el === btn;
      el.classList.toggle('gp-hero__size-btn--active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var id = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-variant-title');
    var price = parseInt(btn.getAttribute('data-variant-price'), 10);
    if (variantInput) variantInput.value = id;
    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    if (sizeSelected) sizeSelected.textContent = ' · ' + title;
    if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.textContent = defaultCtaLabel; }
    document.dispatchEvent(new CustomEvent('gp:variantChanged', {
      detail: { variantId: id, title: title, priceCents: isNaN(price) ? null : price, available: true }
    }));
  }
  section.querySelectorAll('.gp-hero__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { selectSize(btn); });
  });

  // ---------- Quantity ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');
  function setQty(n) { var v = parseInt(n, 10); if (isNaN(v) || v < 1) v = 1; if (qtyInput) qtyInput.value = v; }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) { qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); }); }

  // ---------- Cross-promo add to cart ----------
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
  };
  function transientAdded(btn) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added';
    btn.dataset.added = '1';
  }
  section.querySelectorAll('[data-xsell-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.added === '1') return;
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      window.GP_ADD_TO_CART([{ id: id, quantity: 1 }])
        .then(function () { transientAdded(btn); })
        .catch(function () { transientAdded(btn); });
    });
  });

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '').replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi; lightboxImg.alt = alt || '';
    lightbox.hidden = false; lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open'); lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) stage.addEventListener('click', function (e) {
    var img = e.target.closest('.gp-hero__photo');
    if (img) { e.preventDefault(); openLightbox(img.src, img.alt); }
  });
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target === lightboxImg) closeLightbox(); });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);

  // ---------- Size-guide modal ----------
  var sg = section.querySelector('[data-sizeguide]');
  function openSizeGuide() {
    if (!sg) return;
    sg.hidden = false; sg.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    if (!sg) return;
    sg.classList.remove('is-open'); sg.hidden = true;
    document.documentElement.style.overflow = '';
  }
  section.querySelectorAll('[data-open-sizeguide]').forEach(function (b) { b.addEventListener('click', openSizeGuide); });
  if (sg) {
    sg.addEventListener('click', function (e) { if (e.target === sg) closeSizeGuide(); });
    var sgClose = sg.querySelector('[data-close-sizeguide]');
    if (sgClose) sgClose.addEventListener('click', closeSizeGuide);
  }
  // Open if URL hash points at the size guide (e.g. the details section link)
  if (sg && window.location.hash === '#size-guide') openSizeGuide();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#size-guide"]');
    if (a && sg) { e.preventDefault(); openSizeGuide(); }
  });

  // ---------- Escape closes any open overlay ----------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lightbox && !lightbox.hidden) closeLightbox();
    if (sg && !sg.hidden) closeSizeGuide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-harness-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Size/variant changes from the hero update the sticky bar's size label + price.
  document.addEventListener('gp:variantChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.title) {
      colorLabel.textContent = detail.title;
    }
    if (priceEl && typeof detail.priceCents === 'number') {
      priceEl.textContent = formatMoney(detail.priceCents);
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-harness-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-home-amazon-reviews"]) return;
  try {
    
  document.querySelectorAll('[data-section-type="gp-azr"]').forEach(function (root) {
    var track = root.querySelector('[data-azr-track]');
    var prev = root.querySelector('[data-azr-prev]');
    var next = root.querySelector('[data-azr-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.gp-azr__card');
      return card ? card.getBoundingClientRect().width + 18 : 320;
    }
    function update() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= maxScroll;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-home-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-cats"]').forEach(function (section) {
  var grid = section.querySelector('[data-cats-grid]');
  var btn = section.querySelector('[data-cats-toggle]');
  if (!grid || !btn) return;
  var label = btn.querySelector('[data-cats-toggle-label]');
  var moreText = label ? label.textContent : 'Show more collections';
  var lessText = 'Show fewer';
  btn.addEventListener('click', function () {
    var collapsed = grid.getAttribute('data-collapsed') === 'true';
    if (collapsed) {
      grid.removeAttribute('data-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = lessText;
    } else {
      grid.setAttribute('data-collapsed', 'true');
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = moreText;
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-compare"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-compare"]').forEach(function (section) {
  var btns = Array.prototype.slice.call(section.querySelectorAll('[data-compare-mode]'));
  var panels = Array.prototype.slice.call(section.querySelectorAll('[data-compare-panel]'));
  if (!btns.length || !panels.length) return;

  function activate(idx) {
    btns.forEach(function (b) {
      var on = b.getAttribute('data-compare-mode') === String(idx);
      b.classList.toggle('gp-compare__toggle-btn--active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-compare-panel') === String(idx);
      p.classList.toggle('gp-compare__panel--active', on);
      p.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () { activate(b.getAttribute('data-compare-mode')); });
    b.addEventListener('keydown', function (e) {
      var i = btns.indexOf(b);
      if (e.key === 'ArrowRight') { e.preventDefault(); btns[(i + 1) % btns.length].focus(); btns[(i + 1) % btns.length].click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); btns[(i - 1 + btns.length) % btns.length].focus(); btns[(i - 1 + btns.length) % btns.length].click(); }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-hero"] && !Shopify.designMode) return;
  try {
    
/* gp-leash-hero build 2026-06-24d — swatch binds main buy box to the LEASH only; collar lives in the cross-sell. type-guarded. cache-bust */
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var collarColorManual = false;
  var slideIndex = 0;
  try { if (!window.__gpHeroBuild) { window.__gpHeroBuild = 'leash-2026-06-24d'; if (window.console) console.log('[GlowPups] leash-hero JS build leash-2026-06-24d'); } } catch (e) {}

  // Defensive guard: this section is the LEASH PDP, so the main buy box must never paint a
  // non-leash product. gpTypeOk() lets a future handle-wiring regression (or stale paired data)
  // fall back to the correct server-rendered product instead of cross-painting a collar.
  var gpExpectType = section.getAttribute('data-gp-pdp-type') || 'leash';
  function gpTypeOk(json) {
    if (!json || !gpExpectType) return true;
    var t = ((json.type || '') + ' ' + (json.title || '')).toLowerCase();
    // Bail ONLY when the fetched product is POSITIVELY the opposite type — never on mere absence
    // of the expected keyword — so a correctly-typed product is never suppressed (no false-negative).
    if (gpExpectType === 'collar') return t.indexOf('leash') === -1;
    if (gpExpectType === 'leash') return t.indexOf('collar') === -1;
    return true;
  }

  // ---------- DOM refs ----------
  var stage = section.querySelector('.gp-hero__stage');
  var thumbsWrap = section.querySelector('.gp-hero__thumbs');
  var titleEl = section.querySelector('.gp-hero__title');
  var priceEl = section.querySelector('.gp-hero__price');
  var subEl = section.querySelector('.gp-hero__sub');
  var selectedLabel = section.querySelector('.gp-hero__colors-selected');
  var formIdInput = section.querySelector('.gp-hero__form input[name="id"]');
  var ctaBtn = section.querySelector('.gp-hero__cta');
  var collarLabel = section.querySelector('.gp-hero__collar-dot-label');
  var collarSize = section.querySelector('.gp-hero__collar-size');
  var collarAdd = section.querySelector('.gp-hero__collar-add');
  var collarUpsell = section.querySelector('.gp-hero__upsell');
  var collarTitle = section.querySelector('.gp-hero__upsell-collar-title');
  var collarThumb = section.querySelector('.gp-hero__upsell-thumb-photo');
  var collarThumbWrap = section.querySelector('.gp-hero__upsell-thumb');

  // ---------- Helpers ----------
  function getSwatches() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__swatch'));
  }
  function getCollarDots() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__collar-dot'));
  }
  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function renderGallery() {
      slides.forEach(function (el, i) {
        el.classList.toggle('gp-hero__slide--active', i === slideIndex);
      });
      thumbs.forEach(function (el, i) {
        el.classList.toggle('gp-hero__thumb--active', i === slideIndex);
      });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex - 1 + slides.length) % slides.length;
      renderGallery();
    };
    if (nextBtn) nextBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex + 1) % slides.length;
      renderGallery();
    };
    thumbs.forEach(function (el, i) {
      el.onclick = function () { slideIndex = i; renderGallery(); };
    });
    renderGallery();
  }
  bindGallery();

  function rebuildGallery(images) {
    if (!stage || !thumbsWrap || !images || !images.length) return;
    var arrows = stage.querySelectorAll('.gp-hero__arrow');
    // Clear out existing slides (keep arrows)
    Array.prototype.slice.call(stage.querySelectorAll('.gp-hero__slide')).forEach(function (n) { n.remove(); });
    thumbsWrap.innerHTML = '';
    var max = Math.min(images.length, 5);
    for (var i = 0; i < max; i++) {
      var src = images[i];
      var fullUrl = src.indexOf('//') === 0 ? src : (src.indexOf('http') === 0 ? src : src);
      // Build slide
      var slide = document.createElement('div');
      slide.className = 'gp-hero__slide' + (i === 0 ? ' gp-hero__slide--active' : '');
      slide.setAttribute('data-slide-index', String(i));
      var img = document.createElement('img');
      img.className = 'gp-hero__photo';
      img.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=900' : '&width=900');
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.alt = '';
      slide.appendChild(img);
      // Insert before arrows so arrows stay on top
      stage.insertBefore(slide, arrows[0] || null);
      // Build thumb
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'gp-hero__thumb' + (i === 0 ? ' gp-hero__thumb--active' : '');
      thumb.setAttribute('data-thumb-index', String(i));
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));
      var tImg = document.createElement('img');
      tImg.className = 'gp-hero__thumb-photo';
      tImg.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=160' : '&width=160');
      tImg.loading = 'lazy';
      tImg.alt = '';
      thumb.appendChild(tImg);
      thumbsWrap.appendChild(thumb);
    }
    slideIndex = 0;
    bindGallery();
  }

  // ---------- Collar size rebuild ----------
  function rebuildCollarSizes(collarJson) {
    if (!collarSize || !collarJson || !collarJson.variants) return;
    var current = collarSize.value;
    collarSize.innerHTML = '';
    var firstAvailableId = null;
    collarJson.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.setAttribute('data-variant-price', String(v.price));
      opt.textContent = v.title + (v.available ? '' : ' — sold out');
      if (!v.available) opt.disabled = true;
      if (firstAvailableId === null && v.available) firstAvailableId = String(v.id);
      collarSize.appendChild(opt);
    });
    var matched = false;
    Array.prototype.slice.call(collarSize.options).forEach(function (o) {
      if (!matched && o.value === current && !o.disabled) {
        o.selected = true;
        matched = true;
      }
    });
    if (!matched && firstAvailableId) {
      collarSize.value = firstAvailableId;
    }
    if (collarAdd) collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
    updateBundlePricing();
  }

  // ---------- Bundle pricing (subtotal row + CTA label) ----------
  var bundleEls = {
    upsell: section.querySelector('.gp-hero__upsell'),
    strike: section.querySelector('[data-bundle-strike]'),
    total: section.querySelector('[data-bundle-total]'),
    savingsPill: section.querySelector('[data-bundle-savings]'),
    addLabel: section.querySelector('[data-collar-add-label]')
  };
  function getSelectedCollarCents() {
    if (!collarSize || !collarSize.selectedOptions || !collarSize.selectedOptions[0]) return null;
    var raw = collarSize.selectedOptions[0].getAttribute('data-variant-price');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }
  function updateBundlePricing() {
    if (!bundleEls.upsell) return;
    var leashCents = parseInt(bundleEls.upsell.getAttribute('data-leash-price-cents'), 10);
    if (isNaN(leashCents)) leashCents = 0;
    var collarCents = getSelectedCollarCents();
    if (collarCents == null) {
      var fallback = parseInt(bundleEls.upsell.getAttribute('data-collar-price-cents'), 10);
      collarCents = isNaN(fallback) ? 0 : fallback;
    } else {
      bundleEls.upsell.setAttribute('data-collar-price-cents', String(collarCents));
    }
    var savingsCents = parseInt(bundleEls.upsell.getAttribute('data-bundle-savings-cents'), 10);
    if (isNaN(savingsCents)) savingsCents = 0;
    var fullTotal = leashCents + collarCents;
    var bundleTotal = Math.max(0, fullTotal - savingsCents);
    if (bundleEls.strike) bundleEls.strike.textContent = formatMoney(fullTotal);
    if (bundleEls.total) bundleEls.total.textContent = formatMoney(bundleTotal);
    if (bundleEls.savingsPill) bundleEls.savingsPill.textContent = 'Save ' + formatMoney(savingsCents).replace(/\.00$/, '');
    if (bundleEls.addLabel && collarAdd) {
      var base = collarAdd.getAttribute('data-collar-add-label') || 'Add to bundle';
      bundleEls.addLabel.textContent = base + ' — ' + formatMoney(bundleTotal);
    }
  }
  function setLeashPriceCents(cents) {
    if (!bundleEls.upsell || cents == null) return;
    bundleEls.upsell.setAttribute('data-leash-price-cents', String(cents));
    updateBundlePricing();
  }

  // ---------- Apply leash color: AJAX swap ----------
  function applyLeashSwatch(swatch) {
    var handle = swatch.dataset.leashHandle;
    var label = swatch.dataset.colorLabel;
    var collarHandle = swatch.dataset.collarHandle;
    var url = swatch.dataset.leashUrl;

    // Optimistic UI
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;

    // Optimistic paint: show the LEASH instantly from swatch data so there is no
    // lag and no chance of any other image showing during the AJAX fetch.
    if (gpTypeOk({ title: swatch.dataset.leashTitle })) {
      if (titleEl && swatch.dataset.leashTitle) titleEl.textContent = swatch.dataset.leashTitle;
      if (priceEl && swatch.dataset.leashPrice) {
        var optCents = parseInt(swatch.dataset.leashPrice, 10);
        if (!isNaN(optCents)) priceEl.textContent = formatMoney(optCents);
      }
      if (formIdInput && swatch.dataset.leashVariantId) formIdInput.value = swatch.dataset.leashVariantId;
      if (swatch.dataset.leashImage && stage) {
        slideIndex = 0;
        var optSlides = stage.querySelectorAll('.gp-hero__slide');
        optSlides.forEach(function (sl, i) { sl.classList.toggle('gp-hero__slide--active', i === 0); });
        var optPhoto = stage.querySelector('.gp-hero__slide .gp-hero__photo');
        if (optPhoto) optPhoto.src = swatch.dataset.leashImage;
      }
    }

    if (url) {
      try { history.replaceState({}, '', url); } catch (err) { /* noop */ }
    }

    if (!handle) return;

    // Race guard: only the LATEST swatch's response may paint the buy box / sync other sections.
    // Stale, out-of-order /products/*.js responses from rapid clicking are dropped — this is what
    // prevents the title/label/swatch "musical chairs" desync.
    var reqToken = (section.__gpReq = (section.__gpReq || 0) + 1);

    // Fetch leash + collar in parallel
    var leashPromise = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    var collarPromise = collarHandle
      ? fetch('/products/' + collarHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([leashPromise, collarPromise]).then(function (results) {
      if (reqToken !== section.__gpReq) return; // a newer swatch was clicked — drop this stale response
      var leashJson = results[0];
      var collarJson = results[1];

      // ---- Leash side ----
      if (leashJson && gpTypeOk(leashJson)) {
        var firstAvail = null;
        for (var i = 0; i < leashJson.variants.length; i++) {
          if (leashJson.variants[i].available) { firstAvail = leashJson.variants[i]; break; }
        }
        var leashVariant = firstAvail || leashJson.variants[0];
        if (titleEl) titleEl.textContent = leashJson.title;
        if (priceEl) priceEl.textContent = formatMoney(leashVariant.price);
        if (formIdInput) formIdInput.value = String(leashVariant.id);
        setLeashPriceCents(leashVariant.price);
        if (ctaBtn) {
          ctaBtn.disabled = !leashVariant.available;
          ctaBtn.textContent = leashVariant.available
            ? (ctaBtn.dataset.defaultLabel || ctaBtn.textContent || 'Add to Cart')
            : 'Sold out';
        }
        rebuildGallery(leashJson.images || (leashJson.featured_image ? [leashJson.featured_image] : []));
      }

      // ---- Collar side ----
      if (!collarColorManual && collarUpsell) {
        if (collarJson) {
          if (collarTitle) collarTitle.textContent = collarJson.title;
          if (collarThumb && collarJson.featured_image) {
            collarThumb.src = collarJson.featured_image + (collarJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
            collarThumb.alt = collarJson.title;
          } else if (!collarThumb && collarThumbWrap && collarJson.featured_image) {
            collarThumbWrap.innerHTML = '<img class="gp-hero__upsell-thumb-photo" src="' + collarJson.featured_image + '?width=240" alt="" loading="lazy">';
            collarThumb = collarThumbWrap.querySelector('.gp-hero__upsell-thumb-photo');
          }
          rebuildCollarSizes(collarJson);
          collarUpsell.dataset.collarHandle = collarJson.handle;
          collarUpsell.dataset.collarProductId = String(collarJson.id);
          // Mirror collar dot active state
          getCollarDots().forEach(function (el) {
            var on = el.dataset.collarHandle === collarJson.handle;
            el.classList.toggle('gp-hero__collar-dot--active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (collarLabel) collarLabel.textContent = label;
        }
      }

      // Cross-section sync (matched-set, sticky-atc)
      document.dispatchEvent(new CustomEvent('gp:colorChanged', {
        detail: {
          colorId: handle,
          label: label,
          handle: handle,
          variantId: leashJson && leashJson.variants[0] ? leashJson.variants[0].id : null,
          collarHandle: collarHandle || null,
          collarJson: collarJson,
          leashImage: leashJson && leashJson.featured_image ? leashJson.featured_image : null,
          collarImage: collarJson && collarJson.featured_image ? collarJson.featured_image : null,
          leashPrice: leashJson && leashJson.variants[0] ? leashJson.variants[0].price : null,
          leashTitle: leashJson ? leashJson.title : null
        }
      }));
    });
  }

  // Hex-fill (fallback) handler — legacy behavior when no collection is set
  function applyLeashHexSwatch(swatch) {
    var id = swatch.dataset.colorId;
    var label = swatch.dataset.colorLabel;
    var hex = swatch.dataset.colorHex;
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;
    slideIndex = 0;
    bindGallery();
    if (!collarColorManual) {
      getCollarDots().forEach(function (el) {
        var on = el.dataset.collarColor === id;
        el.classList.toggle('gp-hero__collar-dot--active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = label;
    }
    document.dispatchEvent(new CustomEvent('gp:colorChanged', {
      detail: { colorId: id, label: label, hex: hex }
    }));
  }

  // Wire swatch clicks
  getSwatches().forEach(function (el) {
    el.addEventListener('click', function () {
      collarColorManual = false;
      if (el.dataset.leashHandle) {
        applyLeashSwatch(el);
      } else {
        applyLeashHexSwatch(el);
      }
    });
  });

  // Listen for color changes coming from other sections (matched-set band, sticky-atc).
  document.addEventListener('gp:colorChanged', function (e) {
    if (!e.detail) return;
    var detail = e.detail;
    var active = section.querySelector('.gp-hero__swatch--active');
    var activeHandle = active && (active.dataset.leashHandle || active.dataset.colorId);
    var incoming = detail.handle || detail.colorId;
    if (activeHandle === incoming) return;
    // Find matching swatch and trigger its handler without re-dispatching
    var target = null;
    var pool = getSwatches();
    for (var i = 0; i < pool.length; i++) {
      var s = pool[i];
      var sHandle = s.dataset.leashHandle || s.dataset.colorId;
      if (sHandle === incoming) { target = s; break; }
    }
    if (!target) return;
    collarColorManual = false;
    // Avoid echo: temporarily detach our listener? simpler: re-render UI directly without dispatching.
    if (target.dataset.leashHandle) {
      // Reuse same AJAX flow; dispatch will run but the active check above will short-circuit it.
      applyLeashSwatch(target);
    } else {
      applyLeashHexSwatch(target);
    }
  });

  // ---------- Quantity stepper ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');

  function setQty(n) {
    var val = parseInt(n, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (qtyInput) qtyInput.value = val;
  }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () { if (qtyInput.value !== '') setQty(qtyInput.value); });
    qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); });
  }

  // ---------- Collar color manual override ----------
  getCollarDots().forEach(function (el) {
    el.addEventListener('click', function () {
      collarColorManual = true;
      getCollarDots().forEach(function (d) {
        var on = d === el;
        d.classList.toggle('gp-hero__collar-dot--active', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = el.dataset.collarLabel || '';
      // If this dot points at a different collar product, fetch its variants and swap
      var collarHandle = el.dataset.collarHandle;
      if (collarHandle) {
        fetch('/products/' + collarHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (collarJson) {
            if (!collarJson || !collarUpsell) return;
            if (collarTitle) collarTitle.textContent = collarJson.title;
            if (collarThumb && collarJson.featured_image) {
              collarThumb.src = collarJson.featured_image + (collarJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
              collarThumb.alt = collarJson.title;
            }
            rebuildCollarSizes(collarJson);
            collarUpsell.dataset.collarHandle = collarJson.handle;
            collarUpsell.dataset.collarProductId = String(collarJson.id);
          })
          .catch(function () { /* noop */ });
      }
    });
  });

  // ---------- Collar size change ----------
  if (collarSize && collarAdd) {
    collarSize.addEventListener('change', function () {
      collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
      updateBundlePricing();
      resetAdded(collarAdd);
    });
  }

  // ---------- Add-to-cart helper + collar add ----------
  function transientAdded(btn, addedHTML, ms) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = addedHTML;
    btn.dataset.added = '1';
  }
  function resetAdded(btn) {
    if (!btn || btn.dataset.added !== '1') return;
    if (btn.dataset.defaultHtml) btn.innerHTML = btn.dataset.defaultHtml;
    btn.dataset.added = '';
  }
  // Reset the bundle "Added" state when the selection changes (leash color / collar dot),
  // so the button never stays "Added" for a product the user is no longer adding.
  section.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.gp-hero__swatch, .gp-hero__collar-dot')) resetAdded(collarAdd);
  });
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  };

  if (collarAdd) {
    collarAdd.addEventListener('click', function () {
      if (collarAdd.dataset.added === '1') return;
      var addedHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added to bundle ✓';
      var variantId = collarAdd.dataset.collarVariantId;
      if (variantId) {
        window.GP_ADD_TO_CART([{ id: parseInt(variantId, 10), quantity: 1 }])
          .then(function () { transientAdded(collarAdd, addedHTML); })
          .catch(function () { transientAdded(collarAdd, addedHTML); });
      } else {
        transientAdded(collarAdd, addedHTML);
      }
    });
  }

  // Cache the CTA's original label so we can restore it after a sold-out state.
  if (ctaBtn && !ctaBtn.dataset.defaultLabel) {
    ctaBtn.dataset.defaultLabel = ctaBtn.textContent.trim();
  }

  // Sync bundle pricing on init
  updateBundlePricing();

  // ---------- Show-more toggles (leash + collar) ----------
  function wireToggle(btnSelector, targetSelector, expandedLabel, collapsedLabel, labelSelector) {
    var btn = section.querySelector(btnSelector);
    if (!btn) return;
    var target = section.querySelector(targetSelector);
    if (!target) return;
    var labelEl = section.querySelector(labelSelector);
    // Restore the label THIS section's Liquid actually rendered (prevents any cross-section bleed, e.g. "toys").
    var restoreLabel = (labelEl && labelEl.textContent.trim()) ? labelEl.textContent.trim() : collapsedLabel;
    btn.addEventListener('click', function () {
      var collapsed = target.getAttribute('data-collapsed') === 'true';
      if (collapsed) {
        target.removeAttribute('data-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        if (labelEl) labelEl.textContent = expandedLabel;
      } else {
        target.setAttribute('data-collapsed', 'true');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = restoreLabel;
      }
    });
  }
  var colorCount = section.querySelectorAll('.gp-hero__colors .gp-hero__swatch').length;
  var collarCount = section.querySelectorAll('.gp-hero__collar-dots .gp-hero__collar-dot').length;
  wireToggle('[data-toggle-colors]', '.gp-hero__colors', 'Show fewer', 'Show all ' + colorCount + ' colors', '[data-toggle-colors-label]');
  wireToggle('[data-toggle-collar-dots]', '.gp-hero__collar-dots', 'Show fewer', 'Show all ' + collarCount + ' collars', '[data-toggle-collar-dots-label]');

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src;
    // Strip Shopify width suffix to get max-resolution image
    hi = hi.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '');
    // If the URL has _900x etc transformations, strip them
    hi = hi.replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) {
    stage.addEventListener('click', function (e) {
      var img = e.target.closest('.gp-hero__photo');
      if (img) {
        e.preventDefault();
        openLightbox(img.src, img.alt);
      }
    });
  }
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-matched-set"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-set"]').forEach(function (section) {
  var dots = Array.prototype.slice.call(section.querySelectorAll('.gp-set__dot'));
  var colorLabel = section.querySelector('[data-set-color-label]');
  var leashImg = section.querySelector('[data-set-leash-img]');
  var collarImg = section.querySelector('[data-set-collar-img]');
  var collarSize = section.querySelector('[data-collar-size]');
  var addBtn = section.querySelector('[data-set-add]');
  var priceRow = section.querySelector('.gp-set__price-row');
  var strikeEl = section.querySelector('[data-set-strike]');
  var totalEl = section.querySelector('[data-set-total]');
  var savingsEl = section.querySelector('[data-set-savings]');
  var addLabelEl = section.querySelector('[data-set-add-label]');

  function findActive() {
    return section.querySelector('.gp-set__dot--active') || dots[0];
  }
  var initialActive = findActive();
  var state = {
    colorId: initialActive ? (initialActive.dataset.leashHandle || initialActive.dataset.colorId) : null,
    collarSize: collarSize ? collarSize.value : null
  };

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }
  function getSelectedCollarCents() {
    if (!collarSize || !collarSize.selectedOptions || !collarSize.selectedOptions[0]) return null;
    var raw = collarSize.selectedOptions[0].getAttribute('data-variant-price');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }
  function updateSetPricing() {
    if (!priceRow) return;
    var leashCents = parseInt(priceRow.getAttribute('data-set-leash-cents'), 10);
    if (isNaN(leashCents)) leashCents = 0;
    var collarCents = getSelectedCollarCents();
    if (collarCents == null) {
      var fallback = parseInt(priceRow.getAttribute('data-set-collar-cents'), 10);
      collarCents = isNaN(fallback) ? 0 : fallback;
    } else {
      priceRow.setAttribute('data-set-collar-cents', String(collarCents));
    }
    var savingsCents = parseInt(priceRow.getAttribute('data-set-savings-cents'), 10);
    if (isNaN(savingsCents)) savingsCents = 0;
    var fullTotal = leashCents + collarCents;
    var bundleTotal = Math.max(0, fullTotal - savingsCents);
    if (strikeEl) strikeEl.textContent = formatMoney(fullTotal);
    if (totalEl) totalEl.textContent = formatMoney(bundleTotal);
    if (savingsEl) savingsEl.textContent = 'Save ' + formatMoney(savingsCents).replace(/\.00$/, '');
    if (addLabelEl) {
      var base = addLabelEl.getAttribute('data-base') || addLabelEl.textContent.replace(/\s*[—-]\s*\$.*$/, '').trim();
      if (!addLabelEl.getAttribute('data-base')) addLabelEl.setAttribute('data-base', base);
      addLabelEl.textContent = base + ' — ' + formatMoney(bundleTotal);
    }
  }
  function setLeashCents(cents) {
    if (!priceRow || cents == null) return;
    priceRow.setAttribute('data-set-leash-cents', String(cents));
    updateSetPricing();
  }

  function setActiveDotById(id) {
    dots.forEach(function (dot) {
      var dotId = dot.dataset.leashHandle || dot.dataset.colorId;
      var on = dotId === id;
      dot.classList.toggle('gp-set__dot--active', on);
      dot.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function applyLabel(label) {
    if (colorLabel) colorLabel.textContent = label + ' · matched throughout';
  }

  function rebuildCollarSizesFromJson(collarJson) {
    if (!collarSize || !collarJson || !collarJson.variants) return;
    var current = collarSize.value;
    collarSize.innerHTML = '';
    var firstAvailableId = null;
    collarJson.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = v.title + (v.available ? '' : ' — sold out');
      if (!v.available) opt.disabled = true;
      if (firstAvailableId === null && v.available) firstAvailableId = String(v.id);
      collarSize.appendChild(opt);
    });
    var matched = false;
    Array.prototype.slice.call(collarSize.options).forEach(function (o) {
      if (!matched && o.value === current && !o.disabled) {
        o.selected = true;
        matched = true;
      }
    });
    if (!matched && firstAvailableId) collarSize.value = firstAvailableId;
    state.collarSize = collarSize.value;
    if (addBtn) addBtn.setAttribute('data-collar-variant', collarSize.value);
    // Re-stamp data-variant-price too (for the price reader)
    Array.prototype.slice.call(collarSize.options).forEach(function (o) {
      var v = collarJson.variants.filter(function (vv) { return String(vv.id) === o.value; })[0];
      if (v) o.setAttribute('data-variant-price', String(v.price));
    });
    updateSetPricing();
  }

  function applyDot(dot) {
    var id = dot.dataset.leashHandle || dot.dataset.colorId;
    var label = dot.dataset.colorLabel;
    state.colorId = id;
    setActiveDotById(id);
    applyLabel(label);
    // Stash leash price if the dot has one (image-swatch carries data-leash-variant-id; we'll read price from gp:colorChanged when leashJson lands)
    var leashVariantPrice = dot.getAttribute('data-leash-variant-price');
    if (leashVariantPrice) setLeashCents(parseInt(leashVariantPrice, 10));
    var leashImage = dot.dataset.leashImage;
    var collarImage = dot.dataset.collarImage;
    if (leashImg && leashImage) {
      if (leashImg.tagName === 'IMG') {
        leashImg.src = leashImage;
        leashImg.alt = label;
      }
    }
    if (collarImg && collarImage) {
      if (collarImg.tagName === 'IMG') {
        collarImg.src = collarImage;
        collarImg.alt = label;
      }
    }
    if (addBtn) {
      if (dot.dataset.leashVariantId) addBtn.setAttribute('data-leash-variant', dot.dataset.leashVariantId);
      if (dot.dataset.collarVariantId) addBtn.setAttribute('data-collar-variant', dot.dataset.collarVariantId);
    }
  }

  // Direct dot clicks: update local state, fetch collar JSON to rebuild sizes,
  // dispatch gp:colorChanged so hero + sticky-atc sync.
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      applyDot(dot);
      resetSetAdded(addBtn);
      var collarHandle = dot.dataset.collarHandle;
      var leashHandle = dot.dataset.leashHandle;
      if (collarHandle) {
        fetch('/products/' + collarHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (collarJson) {
            if (collarJson) rebuildCollarSizesFromJson(collarJson);
            document.dispatchEvent(new CustomEvent('gp:colorChanged', {
              detail: {
                colorId: dot.dataset.leashHandle || dot.dataset.colorId,
                label: dot.dataset.colorLabel,
                handle: leashHandle,
                collarHandle: collarHandle,
                collarJson: collarJson,
                leashImage: dot.dataset.leashImage || null,
                collarImage: dot.dataset.collarImage || null,
                variantId: dot.dataset.leashVariantId || null
              }
            }));
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('gp:colorChanged', {
              detail: {
                colorId: dot.dataset.leashHandle || dot.dataset.colorId,
                label: dot.dataset.colorLabel,
                handle: leashHandle,
                leashImage: dot.dataset.leashImage || null,
                variantId: dot.dataset.leashVariantId || null
              }
            }));
          });
      } else {
        document.dispatchEvent(new CustomEvent('gp:colorChanged', {
          detail: {
            colorId: dot.dataset.leashHandle || dot.dataset.colorId,
            label: dot.dataset.colorLabel,
            hex: dot.dataset.colorHex
          }
        }));
      }
    });
  });

  // React to color changes coming from other sections.
  document.addEventListener('gp:colorChanged', function (e) {
    if (!e.detail) return;
    var detail = e.detail;
    var incoming = detail.handle || detail.colorId;
    if (incoming === state.colorId) return;
    resetSetAdded(addBtn);
    // Find local dot that matches
    var target = null;
    for (var i = 0; i < dots.length; i++) {
      var dotId = dots[i].dataset.leashHandle || dots[i].dataset.colorId;
      if (dotId === incoming) { target = dots[i]; break; }
    }
    if (target) {
      applyDot(target);
    } else {
      // No matching dot — just sync the label
      state.colorId = incoming;
      if (detail.label) applyLabel(detail.label);
    }
    if (detail.collarJson) {
      rebuildCollarSizesFromJson(detail.collarJson);
    }
    if (typeof detail.leashPrice === 'number') {
      setLeashCents(detail.leashPrice);
    }
    if (leashImg && detail.leashImage && leashImg.tagName === 'IMG') {
      leashImg.src = detail.leashImage;
    }
    if (collarImg && detail.collarImage && collarImg.tagName === 'IMG') {
      collarImg.src = detail.collarImage;
    }
  });

  // Init pricing on load
  updateSetPricing();

  if (collarSize) {
    collarSize.addEventListener('change', function () {
      state.collarSize = collarSize.value;
      if (addBtn) addBtn.setAttribute('data-collar-variant', collarSize.value);
      updateSetPricing();
      resetSetAdded(addBtn);
    });
  }

  // Add the Set
  function transientAdded(btn) {
    if (btn.dataset.added) return;
    var labelEl = btn.querySelector('[data-set-add-label]');
    if (!labelEl) return;
    if (!labelEl.dataset.defaultLabel) labelEl.dataset.defaultLabel = labelEl.textContent;
    labelEl.textContent = 'Set added ✓';
    btn.dataset.added = '1';
  }
  function resetSetAdded(btn) {
    if (!btn || !btn.dataset.added) return;
    var l = btn.querySelector('[data-set-add-label]');
    if (l && l.dataset.defaultLabel) l.textContent = l.dataset.defaultLabel;
    btn.dataset.added = '';
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.dataset.added) return;
      var leashVariant = addBtn.dataset.leashVariant;
      var collarVariant = addBtn.dataset.collarVariant;
      var items = [];
      if (leashVariant) items.push({ id: parseInt(leashVariant, 10), quantity: 1 });
      if (collarVariant) items.push({ id: parseInt(collarVariant, 10), quantity: 1 });
      if (items.length === 0) { transientAdded(addBtn); return; }
      var addFn = window.GP_ADD_TO_CART || function (i) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: i })
        });
      };
      addFn(items)
        .then(function () { transientAdded(addBtn); })
        .catch(function () { transientAdded(addBtn); });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  document.addEventListener('gp:colorChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.label) {
      colorLabel.textContent = detail.label;
    }
    if (priceEl) {
      if (typeof detail.leashPrice === 'number') {
        priceEl.textContent = formatMoney(detail.leashPrice);
      } else if (detail.price) {
        priceEl.textContent = detail.price;
      }
    }
    if (titleEl && detail.leashTitle) {
      titleEl.textContent = detail.leashTitle;
    }
    if (detail.leashImage) {
      if (thumbImg) {
        thumbImg.src = detail.leashImage + (detail.leashImage.indexOf('?') === -1 ? '?width=80' : '&width=80');
      } else if (thumbWrap) {
        thumbWrap.innerHTML = '<img class="gp-sticky__img" src="' + detail.leashImage + '?width=80" loading="lazy" alt="">';
        thumbImg = thumbWrap.querySelector('.gp-sticky__img');
      }
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  if (!carousel || !toggleBtn) return;

  var paused = false;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  if (reducedMotion) setPaused(true);

  // --- Per-video play/pause + IntersectionObserver ---
  // Track user intent per video. If user clicks pause, we keep it paused even when
  // it scrolls back into view. If they never touch it, it autoplays when visible
  // and pauses when off-screen (saves CPU + battery).
  var videos = section.querySelectorAll('[data-ugc-video]');

  function setVideoUiPaused(card, isPaused) {
    var btn = card.querySelector('[data-ugc-vidtoggle]');
    if (btn) {
      btn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      btn.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    }
  }

  videos.forEach(function (video) {
    var card = video.closest('[data-ugc-card]') || video.parentElement;
    var btn = card.querySelector('[data-ugc-vidtoggle]');
    video.userPaused = false; // explicit user intent flag

    if (btn) {
      btn.addEventListener('click', function (e) {
        // Don't navigate to IG when clicking the pause/play overlay
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          video.userPaused = false;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.userPaused = true;
          video.pause();
        }
      });
    }

    video.addEventListener('play', function () { setVideoUiPaused(card, false); });
    video.addEventListener('pause', function () { setVideoUiPaused(card, true); });

    // Initial UI state — videos start paused (autoplay kicks in when IO fires)
    setVideoUiPaused(card, true);
  });

  if (videos.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio > 0.4) {
          if (!video.userPaused && !reducedMotion) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else {
          // Off-screen: pause but don't mark userPaused (so it'll resume on scroll-back)
          if (!video.paused) video.pause();
        }
      });
    }, { threshold: [0, 0.4, 0.75] });

    videos.forEach(function (v) { io.observe(v); });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-toy-companions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-companions"]').forEach(function(section) {
  var row = section.querySelector('.gp-companions__row');
  var prevBtn = section.querySelector('.gp-companions__prev');
  var nextBtn = section.querySelector('.gp-companions__next');

  if (!row) return;

  var scrollAmount = 288;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      row.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      row.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-toy-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-details"]').forEach(function(section) {
  var tabs = section.querySelectorAll('.gp-details__tab');
  var panels = section.querySelectorAll('.gp-details__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('gp-details__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach(function(p) {
        p.classList.remove('gp-details__panel--active');
        p.hidden = true;
      });

      this.classList.add('gp-details__tab--active');
      this.setAttribute('aria-selected', 'true');

      var activePanel = section.querySelector('.gp-details__panel[data-tab="' + targetTab + '"]');
      if (activePanel) {
        activePanel.classList.add('gp-details__panel--active');
        activePanel.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-toy-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-hero"]').forEach(function (section) {
  var collarColorManual = false;
  var slideIndex = 0;

  // ---------- DOM refs ----------
  var stage = section.querySelector('.gp-hero__stage');
  var thumbsWrap = section.querySelector('.gp-hero__thumbs');
  var titleEl = section.querySelector('.gp-hero__title');
  var priceEl = section.querySelector('.gp-hero__price');
  var subEl = section.querySelector('.gp-hero__sub');
  var selectedLabel = section.querySelector('.gp-hero__colors-selected');
  var formIdInput = section.querySelector('.gp-hero__form input[name="id"]');
  var ctaBtn = section.querySelector('.gp-hero__cta');
  var collarLabel = section.querySelector('.gp-hero__collar-dot-label');
  var collarSize = section.querySelector('.gp-hero__collar-size');
  var collarAdd = section.querySelector('.gp-hero__collar-add');
  var collarUpsell = section.querySelector('.gp-hero__upsell');
  var collarTitle = section.querySelector('.gp-hero__upsell-collar-title');
  var collarThumb = section.querySelector('.gp-hero__upsell-thumb-photo');
  var collarThumbWrap = section.querySelector('.gp-hero__upsell-thumb');

  // ---------- Helpers ----------
  function getSwatches() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__swatch'));
  }
  function getCollarDots() {
    return Array.prototype.slice.call(section.querySelectorAll('.gp-hero__collar-dot'));
  }
  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  // ---------- Gallery ----------
  function bindGallery() {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    function renderGallery() {
      slides.forEach(function (el, i) {
        el.classList.toggle('gp-hero__slide--active', i === slideIndex);
      });
      thumbs.forEach(function (el, i) {
        el.classList.toggle('gp-hero__thumb--active', i === slideIndex);
      });
    }
    var prevBtn = section.querySelector('.gp-hero__arrow--prev');
    var nextBtn = section.querySelector('.gp-hero__arrow--next');
    if (prevBtn) prevBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex - 1 + slides.length) % slides.length;
      renderGallery();
    };
    if (nextBtn) nextBtn.onclick = function () {
      if (!slides.length) return;
      slideIndex = (slideIndex + 1) % slides.length;
      renderGallery();
    };
    thumbs.forEach(function (el, i) {
      el.onclick = function () { slideIndex = i; renderGallery(); };
    });
    renderGallery();
  }
  bindGallery();

  function rebuildGallery(images) {
    if (!stage || !thumbsWrap || !images || !images.length) return;
    var arrows = stage.querySelectorAll('.gp-hero__arrow');
    // Clear out existing slides (keep arrows)
    Array.prototype.slice.call(stage.querySelectorAll('.gp-hero__slide')).forEach(function (n) { n.remove(); });
    thumbsWrap.innerHTML = '';
    var max = Math.min(images.length, 5);
    for (var i = 0; i < max; i++) {
      var src = images[i];
      var fullUrl = src.indexOf('//') === 0 ? src : (src.indexOf('http') === 0 ? src : src);
      // Build slide
      var slide = document.createElement('div');
      slide.className = 'gp-hero__slide' + (i === 0 ? ' gp-hero__slide--active' : '');
      slide.setAttribute('data-slide-index', String(i));
      var img = document.createElement('img');
      img.className = 'gp-hero__photo';
      img.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=900' : '&width=900');
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.alt = '';
      slide.appendChild(img);
      // Insert before arrows so arrows stay on top
      stage.insertBefore(slide, arrows[0] || null);
      // Build thumb
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'gp-hero__thumb' + (i === 0 ? ' gp-hero__thumb--active' : '');
      thumb.setAttribute('data-thumb-index', String(i));
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));
      var tImg = document.createElement('img');
      tImg.className = 'gp-hero__thumb-photo';
      tImg.src = fullUrl + (fullUrl.indexOf('?') === -1 ? '?width=160' : '&width=160');
      tImg.loading = 'lazy';
      tImg.alt = '';
      thumb.appendChild(tImg);
      thumbsWrap.appendChild(thumb);
    }
    slideIndex = 0;
    bindGallery();
  }

  // ---------- Collar size rebuild ----------
  function rebuildCollarSizes(collarJson) {
    if (!collarSize || !collarJson || !collarJson.variants) return;
    var current = collarSize.value;
    collarSize.innerHTML = '';
    var firstAvailableId = null;
    collarJson.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.setAttribute('data-variant-price', String(v.price));
      opt.textContent = v.title + (v.available ? '' : ' — sold out');
      if (!v.available) opt.disabled = true;
      if (firstAvailableId === null && v.available) firstAvailableId = String(v.id);
      collarSize.appendChild(opt);
    });
    var matched = false;
    Array.prototype.slice.call(collarSize.options).forEach(function (o) {
      if (!matched && o.value === current && !o.disabled) {
        o.selected = true;
        matched = true;
      }
    });
    if (!matched && firstAvailableId) {
      collarSize.value = firstAvailableId;
    }
    if (collarAdd) collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
    updateBundlePricing();
  }

  // ---------- Bundle pricing (subtotal row + CTA label) ----------
  var bundleEls = {
    upsell: section.querySelector('.gp-hero__upsell'),
    strike: section.querySelector('[data-bundle-strike]'),
    total: section.querySelector('[data-bundle-total]'),
    savingsPill: section.querySelector('[data-bundle-savings]'),
    addLabel: section.querySelector('[data-collar-add-label]')
  };
  function getSelectedCollarCents() {
    if (!collarSize || !collarSize.selectedOptions || !collarSize.selectedOptions[0]) return null;
    var raw = collarSize.selectedOptions[0].getAttribute('data-variant-price');
    if (raw == null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }
  function updateBundlePricing() {
    if (!bundleEls.upsell) return;
    var leashCents = parseInt(bundleEls.upsell.getAttribute('data-leash-price-cents'), 10);
    if (isNaN(leashCents)) leashCents = 0;
    var collarCents = getSelectedCollarCents();
    if (collarCents == null) {
      var fallback = parseInt(bundleEls.upsell.getAttribute('data-collar-price-cents'), 10);
      collarCents = isNaN(fallback) ? 0 : fallback;
    } else {
      bundleEls.upsell.setAttribute('data-collar-price-cents', String(collarCents));
    }
    var savingsCents = parseInt(bundleEls.upsell.getAttribute('data-bundle-savings-cents'), 10);
    if (isNaN(savingsCents)) savingsCents = 0;
    var fullTotal = leashCents + collarCents;
    var bundleTotal = Math.max(0, fullTotal - savingsCents);
    if (bundleEls.strike) bundleEls.strike.textContent = formatMoney(fullTotal);
    if (bundleEls.total) bundleEls.total.textContent = formatMoney(bundleTotal);
    if (bundleEls.savingsPill) bundleEls.savingsPill.textContent = 'Save ' + formatMoney(savingsCents).replace(/\.00$/, '');
    if (bundleEls.addLabel && collarAdd) {
      var base = collarAdd.getAttribute('data-collar-add-label') || 'Add to bundle';
      bundleEls.addLabel.textContent = base + ' — ' + formatMoney(bundleTotal);
    }
  }
  // ---------- Option picker (added 2026-09-24) ----------
  var gpOptWrap = section.querySelector('[data-gp-options]');
  var gpOptState = null;
  function gpOptNames(pj) {
    return (pj.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }
  function gpShowVariantImage(v) {
    var fi = v && v.featured_image;
    var src = fi && (typeof fi === 'string' ? fi : fi.src);
    if (!src) return;
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.gp-hero__thumb'));
    if (!slides.length) return;
    var file = src.split('?')[0].split('/').pop();
    var idx = -1;
    slides.forEach(function (s, i) { var im = s.querySelector('img'); if (idx < 0 && im && (im.getAttribute('src') || '').indexOf(file) > -1) idx = i; });
    if (idx < 0) {
      idx = 0;
      var base = src.indexOf('//') === 0 || src.indexOf('http') === 0 ? src : src;
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var im = slides[0].querySelector('img');
      if (im) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = base + sep + 'width=900'; im.alt = (v.name || v.title || ''); }
      var tim = thumbs[0] && thumbs[0].querySelector('img');
      if (tim) { tim.removeAttribute('srcset'); tim.removeAttribute('sizes'); tim.src = base + sep + 'width=160'; }
    }
    slideIndex = idx;
    bindGallery();
  }
  function gpApplyVariant(v) {
    if (!v) return;
    gpShowVariantImage(v);
    var id = String(v.id);
    if (formIdInput) formIdInput.value = id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    var strike = section.querySelector('.gp-hero__price-strike');
    if (strike) { var cmp = v.compare_at_price || 0; strike.style.display = cmp > v.price ? '' : 'none'; if (cmp > v.price) strike.textContent = formatMoney(cmp); }
    if (ctaBtn) {
      if (!ctaBtn.dataset.defaultLabel) ctaBtn.dataset.defaultLabel = ctaBtn.textContent.trim() || 'Add to Cart';
      ctaBtn.disabled = !v.available;
      ctaBtn.textContent = v.available ? ctaBtn.dataset.defaultLabel : 'Sold out';
    }
    var addBtn = section.querySelector('.gp-hero__collar-add');
    if (addBtn) addBtn.setAttribute('data-pdp-variant-id', id);
    setLeashPriceCents(v.price);
    var stickyPrice = document.querySelector('[data-section-type="gp-sticky"] .gp-sticky__price');
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    try { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); } catch (err) { /* noop */ }
  }
  function gpFind(pj, sel) {
    for (var i = 0; i < pj.variants.length; i++) {
      var ok = true;
      for (var k = 0; k < sel.length; k++) { if (pj.variants[i].options[k] !== sel[k]) { ok = false; break; } }
      if (ok) return pj.variants[i];
    }
    return null;
  }
  function gpDraw() {
    var st = gpOptState, pj = st.pj, names = gpOptNames(pj), html = '';
    for (var k = 0; k < names.length; k++) {
      var seen = {}, vals = [];
      pj.variants.forEach(function (v) {
        for (var j = 0; j < k; j++) { if (v.options[j] !== st.sel[j]) return; }
        var val = v.options[k];
        if (!seen[val]) { seen[val] = { avail: false }; vals.push(val); }
        if (v.available) seen[val].avail = true;
      });
      html += '<div class="gp-hero__opt"><span class="gp-hero__colors-label">' + gpEsc(names[k]) + ': <em>' + gpEsc(st.sel[k]) + '</em></span><div class="gp-hero__size-list" role="radiogroup" aria-label="' + gpEsc(names[k]) + '">';
      vals.forEach(function (val) {
        var on = val === st.sel[k];
        html += '<button type="button" class="gp-hero__size-btn' + (on ? ' is-active' : '') + (seen[val].avail ? '' : ' is-soldout') + '" role="radio" aria-checked="' + on + '" data-opt="' + k + '" data-val="' + gpEsc(val) + '"' + (seen[val].avail ? '' : ' aria-label="' + gpEsc(val) + ' — sold out"') + '>' + gpEsc(val) + '</button>';
      });
      html += '</div></div>';
    }
    gpOptWrap.innerHTML = html;
  }
  function gpEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function gpSelect(k, val) {
    var st = gpOptState, pj = st.pj, sel = st.sel.slice(0, k); sel[k] = val;
    var n = gpOptNames(pj).length;
    // keep later choices when that combination exists; otherwise fall back to the first available match
    var keep = st.sel.slice(0, n); keep[k] = val; for (var j = 0; j < k; j++) keep[j] = sel[j];
    var v = gpFind(pj, keep);
    if (!v || !v.available) {
      var best = null;
      pj.variants.forEach(function (x) {
        for (var j = 0; j <= k; j++) { if (x.options[j] !== sel[j]) return; }
        if (!best || (!best.available && x.available)) best = x;
      });
      if (!v || (best && best.available)) v = best;
    }
    if (!v) return;
    st.sel = v.options.slice(0, n);
    gpDraw(); gpApplyVariant(v);
  }
  function gpRenderOptions(pj, preferId) {
    if (!gpOptWrap || !pj || !pj.variants || !pj.variants.length) return;
    var names = gpOptNames(pj);
    if (pj.variants.length === 1 && names.length <= 1 && (pj.variants[0].title === 'Default Title')) { gpOptWrap.innerHTML = ''; gpOptState = null; return; }
    var v = null, prev = gpOptState;
    if (preferId) pj.variants.forEach(function (x) { if (String(x.id) === String(preferId)) v = x; });
    if (!v && prev) {
      // carry the shopper's choice (e.g. size) across a swatch swap when the new product has it
      pj.variants.forEach(function (x) {
        if (v) return;
        var ok = x.available;
        prev.sel.forEach(function (val, k) { var nm = names[k]; var pk = gpOptNames(prev.pj).indexOf(nm); if (nm && pk > -1 && x.options[k] !== prev.sel[pk]) ok = false; });
        if (ok) v = x;
      });
    }
    if (!v) pj.variants.forEach(function (x) { if (!v && x.available) v = x; });
    if (!v) v = pj.variants[0];
    gpOptState = { pj: pj, sel: v.options.slice(0, names.length) };
    gpDraw();
    if (prev) gpApplyVariant(v);
    else if (/[?&]variant=/.test(window.location.search)) gpShowVariantImage(v);
  }
  if (gpOptWrap) {
    gpOptWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.gp-hero__size-btn');
      if (!b || !gpOptState) return;
      gpSelect(parseInt(b.getAttribute('data-opt'), 10), b.getAttribute('data-val'));
    });
    try {
      var gpInit = JSON.parse(section.querySelector('[data-gp-product-json]').textContent);
      gpRenderOptions(gpInit, gpOptWrap.getAttribute('data-initial-variant'));
    } catch (err) { /* noop */ }
  }

  function setLeashPriceCents(cents) {
    if (!bundleEls.upsell || cents == null) return;
    bundleEls.upsell.setAttribute('data-leash-price-cents', String(cents));
    updateBundlePricing();
  }

  // ---------- Apply leash color: AJAX swap ----------
  function applyLeashSwatch(swatch) {
    var handle = swatch.dataset.leashHandle;
    var label = swatch.dataset.colorLabel;
    var collarHandle = swatch.dataset.collarHandle;
    var url = swatch.dataset.leashUrl;

    // Optimistic UI
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;
    if (url) {
      try { history.replaceState({}, '', url); } catch (err) { /* noop */ }
    }

    if (!handle) return;

    // Fetch leash + collar in parallel
    var leashPromise = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    var collarPromise = collarHandle
      ? fetch('/products/' + collarHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([leashPromise, collarPromise]).then(function (results) {
      var leashJson = results[0];
      var collarJson = results[1];

      // ---- Leash side ----
      if (leashJson) {
        var firstAvail = null;
        for (var i = 0; i < leashJson.variants.length; i++) {
          if (leashJson.variants[i].available) { firstAvail = leashJson.variants[i]; break; }
        }
        var leashVariant = firstAvail || leashJson.variants[0];
        if (titleEl) titleEl.textContent = leashJson.title;
        if (priceEl) priceEl.textContent = formatMoney(leashVariant.price);
        if (formIdInput) formIdInput.value = String(leashVariant.id);
        setLeashPriceCents(leashVariant.price);
        if (ctaBtn) {
          ctaBtn.disabled = !leashVariant.available;
          ctaBtn.textContent = leashVariant.available
            ? (ctaBtn.dataset.defaultLabel || ctaBtn.textContent || 'Add to Cart')
            : 'Sold out';
        }
        gpRenderOptions(leashJson);
        rebuildGallery(leashJson.images || (leashJson.featured_image ? [leashJson.featured_image] : []));
      }

      // ---- Collar side ----
      if (!collarColorManual && collarUpsell) {
        if (collarJson) {
          if (collarTitle) collarTitle.textContent = collarJson.title;
          if (collarThumb && collarJson.featured_image) {
            collarThumb.src = collarJson.featured_image + (collarJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
            collarThumb.alt = collarJson.title;
          } else if (!collarThumb && collarThumbWrap && collarJson.featured_image) {
            collarThumbWrap.innerHTML = '<img class="gp-hero__upsell-thumb-photo" src="' + collarJson.featured_image + '?width=240" alt="" loading="lazy">';
            collarThumb = collarThumbWrap.querySelector('.gp-hero__upsell-thumb-photo');
          }
          rebuildCollarSizes(collarJson);
          collarUpsell.dataset.collarHandle = collarJson.handle;
          collarUpsell.dataset.collarProductId = String(collarJson.id);
          // Mirror collar dot active state
          getCollarDots().forEach(function (el) {
            var on = el.dataset.collarHandle === collarJson.handle;
            el.classList.toggle('gp-hero__collar-dot--active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (collarLabel) collarLabel.textContent = label;
        }
      }

      // Cross-section sync (matched-set, sticky-atc)
      document.dispatchEvent(new CustomEvent('gp:colorChanged', {
        detail: {
          colorId: handle,
          label: label,
          handle: handle,
          variantId: leashJson && leashJson.variants[0] ? leashJson.variants[0].id : null,
          collarHandle: collarHandle || null,
          collarJson: collarJson,
          leashImage: leashJson && leashJson.featured_image ? leashJson.featured_image : null,
          collarImage: collarJson && collarJson.featured_image ? collarJson.featured_image : null,
          leashPrice: leashJson && leashJson.variants[0] ? leashJson.variants[0].price : null,
          leashTitle: leashJson ? leashJson.title : null
        }
      }));
    });
  }

  // Hex-fill (fallback) handler — legacy behavior when no collection is set
  function applyLeashHexSwatch(swatch) {
    var id = swatch.dataset.colorId;
    var label = swatch.dataset.colorLabel;
    var hex = swatch.dataset.colorHex;
    getSwatches().forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('gp-hero__swatch--active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (selectedLabel) selectedLabel.textContent = label;
    slideIndex = 0;
    bindGallery();
    if (!collarColorManual) {
      getCollarDots().forEach(function (el) {
        var on = el.dataset.collarColor === id;
        el.classList.toggle('gp-hero__collar-dot--active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = label;
    }
    document.dispatchEvent(new CustomEvent('gp:colorChanged', {
      detail: { colorId: id, label: label, hex: hex }
    }));
  }

  // Wire swatch clicks
  getSwatches().forEach(function (el) {
    el.addEventListener('click', function () {
      collarColorManual = false;
      if (el.dataset.leashHandle) {
        applyLeashSwatch(el);
      } else {
        applyLeashHexSwatch(el);
      }
    });
  });

  // Listen for color changes coming from other sections (matched-set band, sticky-atc).
  document.addEventListener('gp:colorChanged', function (e) {
    if (!e.detail) return;
    var detail = e.detail;
    var active = section.querySelector('.gp-hero__swatch--active');
    var activeHandle = active && (active.dataset.leashHandle || active.dataset.colorId);
    var incoming = detail.handle || detail.colorId;
    if (activeHandle === incoming) return;
    // Find matching swatch and trigger its handler without re-dispatching
    var target = null;
    var pool = getSwatches();
    for (var i = 0; i < pool.length; i++) {
      var s = pool[i];
      var sHandle = s.dataset.leashHandle || s.dataset.colorId;
      if (sHandle === incoming) { target = s; break; }
    }
    if (!target) return;
    collarColorManual = false;
    // Avoid echo: temporarily detach our listener? simpler: re-render UI directly without dispatching.
    if (target.dataset.leashHandle) {
      // Reuse same AJAX flow; dispatch will run but the active check above will short-circuit it.
      applyLeashSwatch(target);
    } else {
      applyLeashHexSwatch(target);
    }
  });

  // ---------- Quantity stepper ----------
  var qtyInput = section.querySelector('.gp-hero__qty-input');
  var qtyDec = section.querySelector('.gp-hero__qty-dec');
  var qtyInc = section.querySelector('.gp-hero__qty-inc');

  function setQty(n) {
    var val = parseInt(n, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (qtyInput) qtyInput.value = val;
  }
  if (qtyDec) qtyDec.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
  if (qtyInc) qtyInc.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () { if (qtyInput.value !== '') setQty(qtyInput.value); });
    qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); });
  }

  // ---------- Collar color manual override ----------
  getCollarDots().forEach(function (el) {
    el.addEventListener('click', function () {
      collarColorManual = true;
      getCollarDots().forEach(function (d) {
        var on = d === el;
        d.classList.toggle('gp-hero__collar-dot--active', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (collarLabel) collarLabel.textContent = el.dataset.collarLabel || '';
      // If this dot points at a different collar product, fetch its variants and swap
      var collarHandle = el.dataset.collarHandle;
      if (collarHandle) {
        fetch('/products/' + collarHandle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (collarJson) {
            if (!collarJson || !collarUpsell) return;
            if (collarTitle) collarTitle.textContent = collarJson.title;
            if (collarThumb && collarJson.featured_image) {
              collarThumb.src = collarJson.featured_image + (collarJson.featured_image.indexOf('?') === -1 ? '?width=240' : '&width=240');
              collarThumb.alt = collarJson.title;
            }
            rebuildCollarSizes(collarJson);
            collarUpsell.dataset.collarHandle = collarJson.handle;
            collarUpsell.dataset.collarProductId = String(collarJson.id);
          })
          .catch(function () { /* noop */ });
      }
    });
  });

  // ---------- Collar size change ----------
  if (collarSize && collarAdd) {
    collarSize.addEventListener('change', function () {
      collarAdd.setAttribute('data-collar-variant-id', collarSize.value);
      updateBundlePricing();
    });
  }

  // ---------- Add-to-cart helper + collar add ----------
  function transientAdded(btn, addedHTML, ms) {
    if (btn.dataset.added === '1') return;
    if (!btn.dataset.defaultHtml) btn.dataset.defaultHtml = btn.innerHTML;
    btn.innerHTML = addedHTML;
    btn.dataset.added = '1';
  }
  window.GP_ADD_TO_CART = window.GP_ADD_TO_CART || function (items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  };

  if (collarAdd) {
    collarAdd.addEventListener('click', function () {
      if (collarAdd.dataset.added === '1') return;
      var addedHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added to bundle ✓';
      var variantId = collarAdd.dataset.collarVariantId;
      if (variantId) {
        window.GP_ADD_TO_CART([{ id: parseInt(variantId, 10), quantity: 1 }])
          .then(function () { transientAdded(collarAdd, addedHTML); })
          .catch(function () { transientAdded(collarAdd, addedHTML); });
      } else {
        transientAdded(collarAdd, addedHTML);
      }
    });
  }

  // Cache the CTA's original label so we can restore it after a sold-out state.
  if (ctaBtn && !ctaBtn.dataset.defaultLabel) {
    ctaBtn.dataset.defaultLabel = ctaBtn.textContent.trim();
  }

  // Sync bundle pricing on init
  updateBundlePricing();

  // ---------- Cross-sell "pairs with" add-to-cart ----------
  section.querySelectorAll('[data-xsell-add]').forEach(function (xbtn) {
    xbtn.addEventListener('click', function () {
      if (xbtn.disabled || xbtn.dataset.added === '1') return;
      var xid = parseInt(xbtn.getAttribute('data-variant-id'), 10);
      if (!xid) return;
      var addedHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> Added';
      window.GP_ADD_TO_CART([{ id: xid, quantity: 1 }])
        .then(function () { transientAdded(xbtn, addedHTML); })
        .catch(function () { transientAdded(xbtn, addedHTML); });
    });
  });

  // ---------- Show-more toggles (leash + collar) ----------
  function wireToggle(btnSelector, targetSelector, expandedLabel, collapsedLabel, labelSelector) {
    var btn = section.querySelector(btnSelector);
    if (!btn) return;
    var target = section.querySelector(targetSelector);
    if (!target) return;
    var labelEl = section.querySelector(labelSelector);
    // Restore the label THIS section's Liquid actually rendered (keeps each PDP's wording section-local).
    var restoreLabel = (labelEl && labelEl.textContent.trim()) ? labelEl.textContent.trim() : collapsedLabel;
    btn.addEventListener('click', function () {
      var collapsed = target.getAttribute('data-collapsed') === 'true';
      if (collapsed) {
        target.removeAttribute('data-collapsed');
        btn.setAttribute('aria-expanded', 'true');
        if (labelEl) labelEl.textContent = expandedLabel;
      } else {
        target.setAttribute('data-collapsed', 'true');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = restoreLabel;
      }
    });
  }
  var colorCount = section.querySelectorAll('.gp-hero__colors .gp-hero__swatch').length;
  var collarCount = section.querySelectorAll('.gp-hero__collar-dots .gp-hero__collar-dot').length;
  wireToggle('[data-toggle-colors]', '.gp-hero__colors', 'Show fewer', 'Show all ' + colorCount + ' toys', '[data-toggle-colors-label]');
  wireToggle('[data-toggle-collar-dots]', '.gp-hero__collar-dots', 'Show fewer', 'Show all ' + collarCount + ' collars', '[data-toggle-collar-dots-label]');

  // ---------- Lightbox ----------
  var lightbox = section.querySelector('[data-lightbox]');
  var lightboxImg = section.querySelector('[data-lightbox-img]');
  var lightboxClose = section.querySelector('[data-lightbox-close]');
  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    var hi = src;
    // Strip Shopify width suffix to get max-resolution image
    hi = hi.replace(/(\?|&)width=\d+(&|$)/, '$1').replace(/\?$/, '');
    // If the URL has _900x etc transformations, strip them
    hi = hi.replace(/_\d+x\d*(\.[a-z]+)/, '$1');
    lightboxImg.src = hi;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    lightbox.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  if (stage) {
    stage.addEventListener('click', function (e) {
      var img = e.target.closest('.gp-hero__photo');
      if (img) {
        e.preventDefault();
        openLightbox(img.src, img.alt);
      }
    });
  }
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-toy-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-section-type="gp-sticky"]');
  if (!bar) return;

  var colorLabel = bar.querySelector('.gp-sticky__color-label');
  var priceEl = bar.querySelector('.gp-sticky__price');
  var titleEl = bar.querySelector('.gp-sticky__title');
  var thumbImg = bar.querySelector('.gp-sticky__img');
  var thumbWrap = bar.querySelector('.gp-sticky__thumb');
  var btn = bar.querySelector('.gp-sticky__btn');

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function getHeroCta() {
    return document.querySelector('.gp-hero__cta');
  }

  function isNearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
  }

  function checkScroll() {
    var cta = getHeroCta();
    if (!cta) return;
    var rect = cta.getBoundingClientRect();
    if (rect.bottom < 0 && !isNearBottom()) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.hidden = true;
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // Variant changes from the hero update the sticky bar's label + price.
  document.addEventListener('gp:variantChanged', function (e) {
    var detail = e.detail || {};
    if (colorLabel && detail.title) {
      colorLabel.textContent = detail.title;
    }
    if (priceEl && typeof detail.priceCents === 'number') {
      priceEl.textContent = formatMoney(detail.priceCents);
    }
  });

  if (btn) {
    btn.addEventListener('click', function () {
      var f = document.querySelector('.gp-hero__form');
      if (f) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.submit();
        }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowpups-toy-ugc"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-section-type="gp-ugc"]').forEach(function (section) {
  var carousel = section.querySelector('[data-ugc-carousel]');
  var toggleBtn = section.querySelector('[data-ugc-toggle]');
  var label = section.querySelector('[data-ugc-label]');
  var iconPause = section.querySelector('.gp-ugc__icon--pause');
  var iconPlay = section.querySelector('.gp-ugc__icon--play');
  if (!carousel || !toggleBtn) return;

  var paused = false;

  function setPaused(next) {
    paused = next;
    carousel.setAttribute('data-paused', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', paused ? 'Play UGC carousel' : 'Pause UGC carousel');
    if (label) label.textContent = paused ? 'Play' : 'Pause';
    if (iconPause) iconPause.hidden = paused;
    if (iconPlay) iconPlay.hidden = !paused;
  }

  toggleBtn.addEventListener('click', function () {
    setPaused(!paused);
  });

  // Respect reduced-motion preference at boot
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setPaused(true);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
